"use client"

import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import SupplierModal from "../../Suppliers/components/SupplierModal";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { motion, AnimatePresence } from "framer-motion";
import {
  X,
  Maximize2,
  Minimize2,
  Copy,
  Search,
  CheckCircle,
  FileText,
  Loader2,
  Building,
  BrainCircuit,
  Sparkles,
  Paperclip,
  MessageSquare,
  Check,
  XCircle,
  RefreshCw,
  Grid,
  Star,
  AlertTriangle,
  Info,
  ListChecks,
  Hash,
  Package,
  TerminalSquare,
  Lock,
  Users,
  FileSpreadsheet,
  Lightbulb,
  Bell,
  AlertCircle,
  Edit3,
  ThumbsUp,
  Reply,
  AtSign,
  Smile,
  Image,
  FileX,
  Download,
  Link,
  Upload,
  File,
  Eye,
  FileCheck,
  Printer,
  Clock,
  History,
  LayoutGrid,
  ClipboardList,
  User,
  Calendar,
  Building2,
  Cpu,
  Zap,
  UserCircle,
  Heart,
  MapPin,
  Mail,
  Phone,
  HeadphonesIcon,
  BadgeCheck,
  Tag,
  Radio,
  ArrowLeft,
  ClipboardX,
  FileIcon,
  Send,
  PackageCheck,
  MessageSquareOff,
  ChevronDown,
  Layers,
  HashIcon,
  Share2,
  Pencil,
  Trash2,
  Plus,
  Flag,
  CreditCard,
  Files,
  FileSearch,
  Maximize,
  Minimize,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
  ClipboardCheck,
  MoreHorizontal
} from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useToast } from "../../../components/ui/use-toast";
import { Textarea } from "../../../components/ui/textarea";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "../../../components/ui/tooltip";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableFooter
} from "../../../components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose
} from "../../../components/ui/dialog";
import { Badge } from "../../../components/ui/badge";
import { ScrollArea } from "../../../components/ui/scroll-area";
import { getOrderItems, createQuotationsForSuppliers, getQuotationItemsByOrderId } from "../../../../ApiCalls/mantisFlowsManangment";
import { getSuppliersBasicInfo, getSuppliersByOrderId, sendEmailToSupplierAndRequester } from "../../../../ApiCalls/mantisFlowsSuppliers";
import { createLog, getLogsByOrderId } from "../../../../ApiCalls/mantisFlowsLogs";
import { createComment, getCommentsByOrderId, updateComment, deleteComment, sendEmailToSuppliers } from "../../../../ApiCalls/mantisFlowsManangment";
import { getSuppliers } from "../../../../ApiCalls/mantisFlowsSuppliers";
import { approveStep, getApprovalFlow, sendIPRRejectionEmail } from "../../../../ApiCalls/mantisFlowsSteps";
import { getDocuments } from "../../../../ApiCalls/mantisFlowsSuppliers";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import { backUrl } from "../../../../utils/backURL";
import { RequestSection} from "../../ControlPanel/Section/Overview_subtabs/RequestSection";
import SuppliersSection from '../../ControlPanel/Section/Overview_subtabs/SuppliersSection';
import { QuotationsSection } from "../../ControlPanel/Section/Overview_subtabs/QuotationsSection";
import {
  loadSuppliers,
  handleSupplierSelection,
  loadQuotationItems,
  saveQuotationData,
} from "../../ControlPanel/Utils/utils";
import { PurchaseOrderSection } from "../../ControlPanel/Section/Overview_subtabs/PurchaseOrderSection";

export default function FlowModalFMM({ data, onClose, isOpen }) {
  // Default to IPR step
  const [selectedStep, setSelectedStep] = useState(
    data?.current_step || "Requests"
  );
  const [selectedContractors, setSelectedContractors] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [copied, setCopied] = useState(false);
  const [isRetrainingMode, setIsRetrainingMode] = useState(false);
  const [retrainingReason, setRetrainingReason] = useState("");
  const [isRetraining, setIsRetraining] = useState(false);
  const [retrainingComplete, setRetrainingComplete] = useState(false);
  const [accuracyBefore, setAccuracyBefore] = useState(0);
  const [accuracyAfter, setAccuracyAfter] = useState(0);
  const [retrainingProgress, setRetrainingProgress] = useState(0);
  const [retrainingStage, setRetrainingStage] = useState("");
  const [editedData, setEditedData] = useState({});
  const [hasEdits, setHasEdits] = useState(false);
  const [orderItems, setOrderItems] = useState([]);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const [itemsError, setItemsError] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(true);
  const [selectedSuppliersIds, setSelectedSuppliersIds] = useState([]);
  const [suppliersError, setSuppliersError] = useState(null);
  const [isLoadingOrderSuppliers, setIsLoadingOrderSuppliers] = useState(false);
  const [stepsApproved, setStepsApproved] = useState({
    Requests: false,
    Suppliers: false,
    Quotations: false,
    "PO Creation": false,
    "Delivery & Reconciliation": false,
    ...data?.stepsApproved,
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [processingMessage, setProcessingMessage] = useState("");
  const [selectedFileToPreview, setSelectedFileToPreview] = useState(null);
  const { toast } = useToast();
  const textareaRef = useRef(null);
  const [filesToPreview, setFilesToPreview] = useState([]);
  const [isGridView, setIsGridView] = useState(false);
  const [showLogModal, setShowLogModal] = useState(false);
  const [logs, setLogs] = useState([]);
  const [processLogs, setProcessLogs] = useState([]);
  const logsInitialized = useRef(false);
  const [orderSuppliers, setOrderSuppliers] = useState([]);
  const [selectedCsSupplierId, setSelectedCsSupplierId] = useState(null);
  const [quotationItems, setQuotationItems] = useState([]);
  const [isLoadingQuotationItems, setIsLoadingQuotationItems] = useState(false);
  const [respondedContractors, setRespondedContractors] = useState([]);
  const [poData, setPOData] = useState(null);
  const [isPreview, setIsPreview] = useState(true);
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState(null);
  const [isLoadingLogs, setIsLoadingLogs] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [commentError, setCommentError] = useState(null);
  const [comments, setComments] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [selectedSupplierForEdit, setSelectedSupplierForEdit] = useState(null);
  const [supplierModalMode, setSupplierModalMode] = useState("create");
  const [showDocumentPanel, setShowDocumentPanel] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [supplierDocuments, setSupplierDocuments] = useState([]);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);
  // Estado para almacenar la referencia a la conexión SSE
  const [suppliersSseConnection, setSuppliersSseConnection] = useState(null);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false); // Nuevo estado para la carga del PDF
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [isRejectProcessing, setIsRejectProcessing] = useState(false);
  // Review modal state
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewReason, setReviewReason] = useState("");
  const [isReviewProcessing, setIsReviewProcessing] = useState(false);
  const [showEmailPreview, setShowEmailPreview] = useState(false);
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);

  console.log(quotationItems, "items in quotation");

  // Usar useRef para mantener una referencia estable a la conexión SSE
  const sseConnectionRef = useRef(null);
  const initialLoadDoneRef = useRef(false);

  // Modificar la función loadOrderSuppliers para manejar correctamente el estado de carga
  const loadOrderSuppliers = useCallback(() => {
    try {
      // Evitar iniciar una nueva conexión si ya existe una activa
      if (sseConnectionRef.current) {
        console.log("Ya existe una conexión SSE activa, no se creará otra");
        return;
      }

      setIsLoadingOrderSuppliers(true);
      const clientId = data?.client_id;
      const orderId = data?.order_id;

      if (!clientId || !orderId) {
        setIsLoadingOrderSuppliers(false);
        return;
      }

      console.log(`Iniciando conexión SSE para orden ${orderId}`);

      // Callback para manejar actualizaciones de proveedores
      const handleSupplierUpdate = (result) => {
        if (result.success && Array.isArray(result.data)) {
          setOrderSuppliers(result.data);

          // Marcar que la carga inicial ha terminado
          if (!initialLoadDoneRef.current) {
            initialLoadDoneRef.current = true;
            setIsLoadingOrderSuppliers(false);
          }

          // Notificar solo en la primera carga o cuando hay nuevos proveedores
          if (
            result.data.length > 0 &&
            (!orderSuppliers.length ||
              result.data.length > orderSuppliers.length)
          ) {
            toast.success(
              `${result.data.length} proveedores disponibles para cotización`
            );
          }
        } else if (!result.success) {
          setIsLoadingOrderSuppliers(false);
          toast.error(result.message || "Error al cargar proveedores");
        }
      };

      // Establecer conexión SSE con un intervalo más largo (10 segundos)
      const connection = getSuppliersByOrderId(
        clientId,
        orderId,
        handleSupplierUpdate,
        10000
      );
      sseConnectionRef.current = connection;
    } catch (error) {
      console.error("Error loading order suppliers:", error);
      setOrderSuppliers([]);
      setIsLoadingOrderSuppliers(false);
    }
  }, [data?.client_id, data?.order_id, orderSuppliers.length]);

  // Optimizar el useEffect para evitar múltiples conexiones
  useEffect(() => {
    // Limpiar cualquier conexión existente al cambiar de paso
    if (sseConnectionRef.current && selectedStep !== "Quotations") {
      console.log("Cerrando conexión SSE al cambiar de paso");
      sseConnectionRef.current.close();
      sseConnectionRef.current = null;
      initialLoadDoneRef.current = false; // Resetear el estado de carga inicial
    }

    // Solo iniciar una nueva conexión si estamos en el paso de cotizaciones y no hay una conexión activa
    if (selectedStep === "Quotations" && !sseConnectionRef.current) {
      loadOrderSuppliers();
    }

    // Función de limpieza para cerrar la conexión SSE cuando se desmonte
    return () => {
      if (sseConnectionRef.current) {
        console.log("Cerrando conexión SSE al desmontar componente");
        sseConnectionRef.current.close();
        sseConnectionRef.current = null;
        initialLoadDoneRef.current = false; // Resetear el estado de carga inicial
      }
    };
  }, [selectedStep, loadOrderSuppliers]);

  // Asegurarse de que isLoadingOrderSuppliers se establezca a false después de un tiempo máximo
  // para evitar que el usuario vea el estado de carga indefinidamente
  useEffect(() => {
    let timeoutId;

    if (isLoadingOrderSuppliers && selectedStep === "Quotations") {
      timeoutId = setTimeout(() => {
        setIsLoadingOrderSuppliers(false);
      }, 10000); // Tiempo máximo de espera: 10 segundos
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isLoadingOrderSuppliers, selectedStep]);

  // Cache selected contractors in localStorage
  useEffect(() => {
    // Load selected contractors from localStorage when component mounts
    const cachedContractors = localStorage.getItem("selectedContractors");
    if (cachedContractors) {
      try {
        setSelectedContractors(JSON.parse(cachedContractors));
      } catch (e) {
        console.error("Error parsing cached contractors:", e);
      }
    }
  }, []);

  // Update localStorage when selectedContractors changes
  useEffect(() => {
    if (selectedContractors.length > 0) {
      localStorage.setItem(
        "selectedContractors",
        JSON.stringify(selectedContractors)
      );
    }
  }, [selectedContractors]);

  // --- Fin State for Grid View ---

  // Función mejorada para agregar un log
  const addLog = async (message, type = "info", step = "null") => {
    try {
      if (!data?.client_id || !data?.order_id) {
        console.error("Missing client ID or order ID for logging", {
          client_id: data?.client_id,
          order_id: data?.order_id,
        });
        return false;
      }

      // Asegurarse de que el mensaje no sea undefined o null
      const safeMessage = message
        ? String(message).trim()
        : "Action not specified";
      const safeType = type ? String(type).trim() : "info";
      const safeStep = step ? String(step).trim() : "null";

      console.log(
        `Adding log: "${safeMessage}" (${safeType}) for step "${safeStep}"`
      );

      // Crear objeto de log para enviar a la API
      const logData = {
        action: safeMessage,
        details: safeType,
        user_name: data?.created_by_name || "System",
        orderId: String(data.order_id),
        step: safeStep,
      };

      // Verificar que todos los datos estén presentes
      console.log("Sending log to server:", logData);

      // Llamar directamente a la API en lugar de usar createLog
      const response = await axios.post(
        `${backUrl}/workflows/p2p/${data.client_id}/logs`,
        logData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Log API response:", response.data);

      // Actualizar el estado local para visualización inmediata
      setLogs((prevLogs) => {
        const newLog = {
          user: data?.created_by_name || "System",
          action: safeMessage,
          details: safeType,
          step: safeStep,
          timestamp: new Date().toISOString(),
        };
        const updatedLogs = [...prevLogs, newLog];
        setProcessLogs(updatedLogs); // Actualizar también processLogs
        return updatedLogs;
      });

      // Recargar los logs si es necesario
      if (selectedStep === "Requests") {
        loadComments();
      }

      return true;
    } catch (error) {
      console.error("Error adding log:", error);
      // Mostrar más detalles del error para depuración
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }

      // Notificar al usuario del error
      toast({
        title: "Error al registrar actividad",
        description: "No se pudo guardar el registro de actividad",
        variant: "destructive",
      });

      return false;
    }
  };

  // --- Ahora los useEffect pueden usar addLog de forma segura ---
  // Efecto principal para inicializar datos
  useEffect(() => {
    if (data) {
      setEditedData(data);
      setFilesToPreview(
        Object.entries(data || {})
          .filter(
            ([key, value]) =>
              value &&
              typeof value === "string" &&
              key.toLowerCase().includes("url")
          )
          .map(([key, value]) => {
            let name = key
              .replace(/file_url_|url/gi, "")
              .replace(/_/g, " ")
              .trim();
            name = name.charAt(0).toUpperCase() + name.slice(1);
            return {
              name: name || "Document",
              url: value,
            };
          })
      );
      if (filesToPreview.length > 0 && !selectedFileToPreview) {
        setSelectedFileToPreview(filesToPreview[0]);
      }
    } else {
      setFilesToPreview([]);
      setSelectedFileToPreview(null);
      setEditedData({});
    }
    setIsRetrainingMode(false);
    setHasEdits(false);
    setIsRetraining(false);
    setRetrainingComplete(false);
    setSearchText("");
    // Reset grid view when data changes
    setIsGridView(false);
  }, [data]);

  // Ajustar altura de textarea automáticamente
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [retrainingReason]);

  // --- New function to render the LEFT panel for IPR ---

  // New state variable for the selected supplier in the CS step

  // Reset selected CS supplier when changing steps or data
  useEffect(() => {
    setSelectedCsSupplierId(null); // Reset when data changes
  }, [data]);

  useEffect(() => {
    setSelectedCsSupplierId(null); // Reset when step changes away from CS
    if (selectedStep !== "CS") {
      // Optionally clear selection if navigating away
      // setSelectedCsSupplierId(null);
    }
  }, [selectedStep]);

  // Función para obtener fechas actuales con formato
  const getCurrentDate = (offsetDays = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + offsetDays);
    return date
      .toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "/");
  };

  // Función para renderizar el contenido de PO Creation
  const renderPOCreatedContent = () => {
    console.log("Rendering PO Creation content with data:", poData);

    if (!poData) {
      return (
        <div className="p-4 flex justify-center items-center h-full">
          {error ? (
            <div className="text-center">
              <XCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-red-800 dark:text-red-300 mb-2">
                Error Loading Purchase Order
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 max-w-md mx-auto">
                {error}
              </p>
              <Button
                variant="outline"
                size="sm"
                className="mt-4"
                onClick={() => {
                  setSelectedStep("Quotations");
                  setError(null);
                }}
              >
                <ArrowLeft className="h-4 w-4 mr-1.5" /> Back to Quotations
              </Button>
            </div>
          ) : (
            <>
              <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
              <span className="ml-3 text-slate-600 dark:text-slate-400">
                Preparing purchase order...
              </span>
            </>
          )}
        </div>
      );
    }

    // Verificar si hay items
    if (!poData.items || poData.items.length === 0) {
      console.warn("PO data exists but has no items:", poData);

      // Intentar recuperar los items del localStorage
      try {
        const savedPOData = localStorage.getItem(
          `quotation_items_${data?.order_id}`
        );
        if (savedPOData) {
          const parsedData = JSON.parse(savedPOData);
          console.log("Recovered items from localStorage:", parsedData);

          // Si se recuperaron items del localStorage y no hay items en poData,
          // filtrar los items por el proveedor seleccionado y asignarlos a poData
          if (parsedData && parsedData.length > 0 && poData.supplierId) {
            // Filtrar solo los items del proveedor seleccionado
            const supplierItems = parsedData.filter(
              (item) => item.supplier_id === poData.supplierId
            );

            // Asignar los items filtrados a poData
            if (supplierItems.length > 0) {
              poData.items = supplierItems;
              console.log(
                "Filtered items for supplier:",
                poData.supplierId,
                supplierItems
              );
            }
          }
        }

        // Asegurarse de que los items estén filtrados por el proveedor seleccionado
        if (poData.items && poData.items.length > 0 && poData.supplierId) {
          // Filtrar solo los items del proveedor seleccionado
          poData.items = poData.items.filter(
            (item) => item.supplier_id === poData.supplierId
          );
        }
      } catch (error) {
        console.error("Error parsing saved PO data:", error);
      }
    }

    return (
      <div className="p-3 overflow-auto h-full">
        <div className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 shadow-sm">
          {/* Encabezado compacto con información esencial */}
          <div className="flex justify-between items-center p-4 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80">
            <div className="flex items-center space-x-3">
              <div className="bg-blue-100 dark:bg-blue-900/30 p-2 rounded">
                <FileText className="h-5 w-5 text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <h2 className="text-lg font-bold text-slate-900 dark:text-slate-100">
                  {poData.poNumber}
                </h2>
                <div className="flex items-center text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                  <Calendar className="h-3 w-3 mr-1" />
                  <span>Issue: {poData.issueDate}</span>
                  <span className="mx-1.5">•</span>
                  <Clock className="h-3 w-3 mr-1" />
                  <span>Delivery: {poData.expectedDeliveryDate}</span>
                </div>
              </div>
            </div>
            <Badge
              variant={isPreview ? "outline" : "success"}
              className={
                isPreview
                  ? "border-amber-300 text-amber-700 dark:border-amber-700 dark:text-amber-400"
                  : ""
              }
            >
              {isPreview ? "PREVIEW" : "CREATED"}
            </Badge>
          </div>

          {/* Contenido principal en diseño de dos columnas */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 p-3">
            {/* Columna izquierda: Tabla de items (ocupa 2/3 del espacio en pantallas medianas) */}
            <div className="md:col-span-2 order-2 md:order-1">
              <div className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 h-full">
                <div className="p-3 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80">
                  <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-200 flex items-center">
                    <ClipboardList className="h-4 w-4 mr-1.5 text-blue-600 dark:text-blue-400" />
                    Order Items
                  </h3>
                </div>

                <div className="overflow-x-auto">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead className="w-[40px]">#</TableHead>
                        <TableHead>Item</TableHead>
                        <TableHead className="text-right w-[60px]">
                          Qty
                        </TableHead>
                        <TableHead className="text-right w-[80px]">
                          Price
                        </TableHead>
                        <TableHead className="text-right w-[80px]">
                          Total
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {poData.items &&
                        poData.items.map((item, index) => {
                          // Asegurar que los valores sean números
                          const quantity = parseFloat(item.quantity) || 0;
                          const unitPrice = parseFloat(item.unit_price) || 0;
                          // Calcular el total correctamente
                          const itemTotal = quantity * unitPrice;

                          return (
                            <TableRow
                              key={`po-item-${index}-${item.item_id || index}`}
                            >
                              <TableCell className="font-medium py-2">
                                {index + 1}
                              </TableCell>
                              <TableCell className="py-2">
                                <div className="text-xs text-slate-500 dark:text-slate-400 truncate max-w-[180px]">
                                  {item.description || item.item_description}
                                </div>
                              </TableCell>
                              <TableCell className="text-right py-2">
                                {quantity}
                              </TableCell>
                              <TableCell className="text-right py-2">
                                ${unitPrice.toFixed(2)}
                              </TableCell>
                              <TableCell className="text-right font-medium py-2">
                                ${itemTotal.toFixed(2)}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          className="text-right font-semibold"
                        >
                          Total:
                        </TableCell>
                        <TableCell className="text-right font-bold text-blue-700 dark:text-blue-300">
                          $
                          {(() => {
                            // Calcular el total sumando precio × cantidad para cada item
                            if (!poData.items || poData.items.length === 0)
                              return "0.00";

                            const total = poData.items.reduce((sum, item) => {
                              const quantity = parseFloat(item.quantity) || 0;
                              const unitPrice =
                                parseFloat(item.unit_price) || 0;
                              return sum + unitPrice * quantity;
                            }, 0);

                            return total.toFixed(2);
                          })()}
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </div>
              </div>
            </div>

            {/* Columna derecha: Información del proveedor y detalles (ocupa 1/3 del espacio en pantallas medianas) */}
            <div className="md:col-span-1 order-1 md:order-2 flex flex-col space-y-3">
              {/* Información del proveedor */}
              <div className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700">
                <div className="p-3 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80">
                  <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-200 flex items-center">
                    <Building2 className="h-4 w-4 mr-1.5 text-blue-600 dark:text-blue-400" />
                    Supplier
                  </h3>
                </div>
                <div className="p-3">
                  <div className="text-sm">
                    <div className="font-medium text-slate-900 dark:text-slate-100">
                      {poData.supplierName}
                    </div>
                    <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                      Supplier ID: {poData.supplierId}
                    </div>
                  </div>
                </div>
              </div>

              {/* Basic Information - Reemplazando Terms y Notes */}
              <div className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700">
                <div className="p-3 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80"></div>
                <div className="p-3">
                  <div className="bg-slate-50/80 dark:bg-slate-800/50 rounded p-3 border border-slate-100 dark:border-slate-700/50">
                    {/* Info Grid - Diseño más limpio */}
                    <div className="grid grid-cols-1 gap-y-3">
                      <div className="flex items-center">
                        <div className="h-6 w-6 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mr-2">
                          <HashIcon className="h-3 w-3 text-indigo-500" />
                        </div>
                        <div>
                          <div className="text-xs text-slate-500 dark:text-slate-400">
                            ID
                          </div>
                          <div className="text-xs font-medium text-slate-800 dark:text-slate-200">
                            {data?.id || "-"}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="h-6 w-6 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mr-2">
                          <AlertCircle className="h-3 w-3 text-indigo-500" />
                        </div>
                        <div>
                          <div className="text-xs text-slate-500 dark:text-slate-400">
                            Priority
                          </div>
                          <span
                            className={`text-xs px-2 py-0.5 rounded-full inline-block ${
                              data?.criticality === "high"
                                ? "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300"
                                : data?.criticality === "medium"
                                ? "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300"
                                : "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
                            }`}
                          >
                            {data?.criticality}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="h-6 w-6 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mr-2">
                          <User className="h-3 w-3 text-indigo-500" />
                        </div>
                        <div>
                          <div className="text-xs text-slate-500 dark:text-slate-400">
                            Created by
                          </div>
                          <div className="text-xs font-medium text-slate-800 dark:text-slate-200">
                            {data?.created_by_name || "-"}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="h-6 w-6 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mr-2">
                          <Calendar className="h-3 w-3 text-indigo-500" />
                        </div>
                        <div>
                          <div className="text-xs text-slate-500 dark:text-slate-400">
                            Date
                          </div>
                          <div className="text-xs font-medium text-slate-800 dark:text-slate-200">
                            {data?.created_at
                              ? new Date(data.created_at).toLocaleDateString()
                              : "-"}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="h-6 w-6 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mr-2">
                          <Calendar className="h-3 w-3 text-indigo-500" />
                        </div>
                        <div>
                          <div className="text-xs text-slate-500 dark:text-slate-400">
                            Area
                          </div>
                          <div className="text-xs font-medium text-slate-800 dark:text-slate-200">
                            {data?.area || "-"}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="h-6 w-6 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mr-2">
                          <Calendar className="h-3 w-3 text-indigo-500" />
                        </div>
                        <div>
                          <div className="text-xs text-slate-500 dark:text-slate-400">
                            Channel
                          </div>
                          <div className="text-xs font-medium text-slate-800 dark:text-slate-200">
                            {data?.origin_channel || "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Timestamp de creación (solo si no es preview) */}
              {!isPreview && poData.createdAt && (
                <div className="text-xs text-slate-500 dark:text-slate-400 flex items-center mt-auto">
                  <Clock className="h-3.5 w-3.5 mr-1" />
                  <span>Created on {poData.createdAt}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderDelivery = () => {
    // Verificar si tenemos datos del PO
    if (!poData) {
      return (
        <div className="p-4 flex justify-center items-center h-full">
          <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
          <span className="ml-3 text-slate-600 dark:text-slate-400">
            Loading purchase order details...
          </span>
        </div>
      );
    }

    // Usar los datos reales del PO en lugar de datos quemados
    const supplierName =
      poData.supplierName || "Supplier information not available";
    const poNumber = poData.poNumber || "PO number not available";

    // Fechas del PO - usar las fechas reales si están disponibles
    const issueDate = poData.issueDate || getCurrentDate(0);
    const deliveryDate = poData.expectedDeliveryDate || getCurrentDate(5);
    const expectedReconciliationDate = getCurrentDate(10); // 10 días después de la fecha actual

    // Calcular el total basado en los items reales
    const calculateTotal = () => {
      if (!poData.items || poData.items.length === 0) return 0;

      return poData.items.reduce((sum, item) => {
        const quantity = parseFloat(item.quantity) || 0;
        const unitPrice = parseFloat(item.unit_price) || 0;
        return sum + quantity * unitPrice;
      }, 0);
    };

    const totalAmount = calculateTotal();
    const formattedTotal = `QAR ${totalAmount.toFixed(2)}`;

    // Función para manejar la impresión
    const handlePrint = () => {
      const printContents =
        document.getElementById("po-details-for-pdf")?.innerHTML;
      if (printContents) {
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        // Es posible que necesites recargar o re-renderizar algunos componentes después de esto
        // o usar un iframe oculto para una impresión más limpia.
      } else {
        console.error("Elemento para imprimir no encontrado.");
        toast({
          title: "Error de Impresión",
          description: "No se pudo encontrar el contenido para imprimir.",
          variant: "destructive",
        });
      }
    };

    // Función para manejar la descarga de PDF
    const handleDownloadPDF = async () => {
      const poElement = document.getElementById("po-details-for-pdf");
      if (!poElement) {
        console.error("Elemento para PDF no encontrado.");
        toast({
          title: "Error al generar PDF",
          description: "No se pudo encontrar el contenido para el PDF.",
          variant: "destructive",
        });
        return;
      }

      setIsGeneratingPDF(true);
      toast({
        title: "Generando PDF...",
        description: "Por favor espera mientras se crea el documento.",
      });

      try {
        // Opciones para html2canvas para mejorar la calidad y manejar el scroll
        const canvas = await html2canvas(poElement, {
          scale: 1, // Aumenta la escala para mejor resolución
          useCORS: true, // Si tienes imágenes de otros dominios
          logging: false, // Desactiva logs de html2canvas en consola
          height: 1000,
          width: 1000,
          windowHeight: 1000,
          windowWidth: 1000,
        });

        const imgData = canvas.toDataURL("image/png");

        // Crear PDF
        // Dimensiones estándar de A4 en mm: 210 x 297
        // jsPDF usa puntos por defecto (1pt = 1/72 inch). Para mm, especificar 'mm'
        const pdf = new jsPDF({
          orientation: "p", // 'p' para portrait, 'l' para landscape
          unit: "mm",
          format: "a4",
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = imgProps.width;
        const imgHeight = imgProps.height;

        // Calcular la relación de aspecto para ajustar la imagen al PDF
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

        // Calcular las dimensiones de la imagen en el PDF
        // Dejar un pequeño margen
        const margin = 10; // margen en mm
        const effectivePdfWidth = pdfWidth - 2 * margin;
        const effectivePdfHeight = pdfHeight - 2 * margin;

        let newImgWidth = imgWidth * ratio;
        let newImgHeight = imgHeight * ratio;

        // Ajustar si excede el área efectiva
        if (newImgWidth > effectivePdfWidth) {
          newImgWidth = effectivePdfWidth;
          newImgHeight = (imgHeight * newImgWidth) / imgWidth;
        }
        if (newImgHeight > effectivePdfHeight) {
          newImgHeight = effectivePdfHeight;
          newImgWidth = (imgWidth * newImgHeight) / imgHeight;
        }

        // Centrar la imagen
        const x = (pdfWidth - newImgWidth) / 2;
        const y = margin; // Empezar desde el margen superior

        pdf.addImage(imgData, "PNG", x, y, newImgWidth, newImgHeight);

        const poNumberForFile =
          poData?.poNumber?.replace(/[^a-z0-9]/gi, "_") || "PO";
        pdf.save(
          `${poNumberForFile}_${new Date().toISOString().slice(0, 10)}.pdf`
        );

        toast({
          title: "PDF Generado",
          description: "El documento PDF se ha descargado.",
          variant: "success",
        });
      } catch (error) {
        console.error("Error al generar PDF:", error);
        toast({
          title: "Error al generar PDF",
          description:
            "Ocurrió un problema al crear el documento. Intenta de nuevo.",
          variant: "destructive",
        });
      } finally {
        setIsGeneratingPDF(false);
      }
    };

    return (
      <div className="p-4 overflow-auto h-full">
        {/* Split layout 50/50 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">
          {/* Left Side: PO Information - ID "po-details-for-pdf" es crucial */}
          <div
            id="po-details-for-pdf"
            className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 p-4 shadow-sm overflow-auto"
          >
            <h3 className="text-base font-semibold text-slate-800 dark:text-slate-200 mb-3 flex items-center">
              <FileCheck className="h-4 w-4 mr-2 text-orange-500" />
              Purchase Order Details
            </h3>

            <div className="grid grid-cols-2 gap-3 mb-3">
              <div>
                <h4 className="text-xs font-medium text-slate-500 dark:text-slate-400 mb-1">
                  PO Number
                </h4>
                <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">
                  {poNumber}
                </p>
              </div>
              <div>
                <h4 className="text-xs font-medium text-slate-500 dark:text-slate-400 mb-1">
                  Issue Date
                </h4>
                <p className="text-sm text-slate-800 dark:text-slate-200">
                  {issueDate}
                </p>
              </div>
              <div>
                <h4 className="text-xs font-medium text-slate-500 dark:text-slate-400 mb-1">
                  Supplier
                </h4>
                <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">
                  {supplierName}
                </p>
              </div>
              <div>
                <h4 className="text-xs font-medium text-slate-500 dark:text-slate-400 mb-1">
                  Status
                </h4>
                <Badge className="bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300 px-1.5 py-0.5 text-xs rounded">
                  <Check className="h-3 w-3 mr-1" /> Delivered
                </Badge>
              </div>
              <div>
                <h4 className="text-xs font-medium text-slate-500 dark:text-slate-400 mb-1">
                  Delivery Date
                </h4>
                <p className="text-sm text-slate-800 dark:text-slate-200">
                  {deliveryDate}
                </p>
              </div>
              <div>
                <h4 className="text-xs font-medium text-slate-500 dark:text-slate-400 mb-1">
                  Total Amount
                </h4>
                <p className="text-sm font-semibold text-orange-600 dark:text-orange-400">
                  {formattedTotal}
                </p>
              </div>
            </div>

            <div className="mb-3">
              <h4 className="text-xs font-medium text-slate-700 dark:text-slate-300 mb-2">
                Order Items
              </h4>
              <div className="border border-slate-200 dark:border-slate-700 rounded overflow-hidden">
                <Table className="text-xs">
                  <TableHeader>
                    <TableRow>
                      <TableHead className="py-1.5 px-2">#</TableHead>
                      <TableHead className="py-1.5 px-2">Description</TableHead>
                      <TableHead className="py-1.5 px-2 text-right">
                        Qty
                      </TableHead>
                      <TableHead className="py-1.5 px-2 text-right">
                        Price
                      </TableHead>
                      <TableHead className="py-1.5 px-2 text-right">
                        Total
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {poData.items &&
                      poData.items.map((item, index) => {
                        const quantity = parseFloat(item.quantity) || 0;
                        const unitPrice = parseFloat(item.unit_price) || 0;
                        const itemTotal = quantity * unitPrice;

                        return (
                          <TableRow key={`delivery-item-${index}`}>
                            <TableCell className="py-1 px-2 font-medium">
                              {index + 1}
                            </TableCell>
                            <TableCell className="py-1 px-2">
                              {item.description || item.item_description}
                            </TableCell>
                            <TableCell className="py-1 px-2 text-right">
                              {quantity}
                            </TableCell>
                            <TableCell className="py-1 px-2 text-right">
                              QAR {unitPrice.toFixed(2)}
                            </TableCell>
                            <TableCell className="py-1 px-2 text-right font-medium">
                              QAR {itemTotal.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    <TableRow className="bg-slate-50 dark:bg-slate-800/50">
                      <TableCell
                        colSpan={4}
                        className="py-1 px-2 text-right font-semibold"
                      >
                        Total:
                      </TableCell>
                      <TableCell className="py-1 px-2 text-right font-semibold">
                        {formattedTotal}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div className="flex space-x-1">
                <Button
                  variant="outline"
                  size="sm"
                  className="text-xs text-slate-600 border-slate-300 h-7 px-2"
                  onClick={handlePrint}
                  disabled={isGeneratingPDF} // Deshabilitar mientras se genera PDF
                >
                  <Printer className="h-3 w-3 mr-1" /> Print
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  className="text-xs text-slate-600 border-slate-300 h-7 px-2"
                  onClick={handleDownloadPDF}
                  disabled={isGeneratingPDF} // Deshabilitar si ya se está generando
                >
                  {isGeneratingPDF ? (
                    <Loader2 className="h-3 w-3 mr-1 animate-spin" />
                  ) : (
                    <Download className="h-3 w-3 mr-1" />
                  )}
                  PDF
                </Button>
              </div>
              <div className="flex items-center text-xs text-slate-500">
                <Clock className="h-3 w-3 mr-1" />
                <span>Created: {issueDate}</span>
              </div>
            </div>
          </div>

          {/* Right Side: Reconciliation */}
          <div className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 p-4 shadow-sm">
            <h3 className="text-base font-semibold text-slate-800 dark:text-slate-200 mb-3 flex items-center">
              <FileSpreadsheet className="h-4 w-4 mr-2 text-purple-500" />
              Reconciliation Status
            </h3>

            <div className="bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded p-6 text-center">
              <ClipboardList className="h-12 w-12 mx-auto mb-3 text-slate-400 dark:text-slate-500" />
              <h4 className="text-base font-medium text-slate-700 dark:text-slate-300 mb-2">
                Pending Reconciliation
              </h4>
              <p className="text-sm text-slate-500 dark:text-slate-400 max-w-md mx-auto mb-4">
                Items have been received but financial reconciliation is
                pending. Finance department will verify invoice against PO and
                complete the process.
              </p>
              <div className="flex justify-center space-x-2">
                <Button variant="outline" size="sm" className="text-xs">
                  <RefreshCw className="h-3.5 w-3.5 mr-1.5" /> Check Status
                </Button>
                <Button variant="outline" size="sm" className="text-xs">
                  <Bell className="h-3.5 w-3.5 mr-1.5" /> Notify Finance
                </Button>
              </div>

              <div className="mt-6 pt-4 border-t border-slate-200 dark:border-slate-700 flex items-center justify-between text-xs text-slate-500 dark:text-slate-400">
                <div className="flex items-center">
                  <Calendar className="h-3.5 w-3.5 mr-1.5" />
                  <span>Expected completion: {expectedReconciliationDate}</span>
                </div>
                <Badge variant="outline" className="text-xs">
                  Finance Dept.
                </Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Para la sección de request

  // Render content based on selected step
  const renderStepContent = () => {
    switch (selectedStep) {
      case "Requests":
        return <RequestSection data={data} currentUser={currentUser} />;
      case "Suppliers":
        return (
          <SuppliersSection
            data={data}
            orderItems={orderItems}
            onSupplierSelect={handleSelectSupplier}
            selectedSupplierId={selectedSupplierId}
          />
        );
      case "Quotations":
        return (
          <QuotationsSection
            data={data}
            addLog={addLog}
            selectedSupplierId={selectedCsSupplierId}
            onSupplierSelect={handleSelectSupplier}
            quotationItems={quotationItems}
            isLoadingQuotationItems={isLoadingQuotationItems}
          />
        );
      case "PO Creation":
        return (
          <PurchaseOrderSection
            data={data}
            addLog={addLog}
            selectedSupplierId={selectedSupplierId}
            onSupplierSelect={handleSelectSupplier}
            quotationItems={quotationItems}
            isLoadingQuotationItems={isLoadingQuotationItems}
          />
        );
      case "Delivery & Reconciliation":
        return renderDelivery();
      default:
        return null;
    }
  };

  // 2. Usar useEffect para controlar cuándo se cargan los comentarios
  // Agrega este useEffect después de la declaración de loadComments
  useEffect(() => {
    if (selectedStep === "Requests") {
      loadComments();
    }
  }, [selectedStep]);
  // Function to handle step approval
  // Modificar handleApproveStep para aceptar un parámetro de acción
  const handleApproveStep = async (action = "approve") => {
    try {
      const clientId = data?.client_id;
      const orderId = data?.order_id;

      if (!clientId || !orderId) {
        addLog("Error: Missing client ID or order ID", "error");
        return;
      }

      // Si es un rechazo, manejarlo de manera diferente
      // Modificar la sección de rechazo en handleApproveStep
      if (action === "reject") {
        // En lugar de usar window.prompt, mostraremos un modal de confirmación
        setShowRejectModal(true);
        return;
      }

      // Continuar con la aprobación normal
      const result = await approveStep(clientId, orderId, selectedStep);

      if (result.success) {
        // Actualizar el estado local
        setStepsApproved((prev) => ({
          ...prev,
          [selectedStep]: true,
        }));
        await addLog(`${selectedStep} step approved.`, "success", selectedStep);
        // Notificar al usuario con la variante default (fondo blanco) en lugar de success
        toast({
          title: `${selectedStep} Approved`,
          description: `The ${selectedStep} step has been approved successfully.`,
          variant: "default",
          className: "border-green-500 bg-white dark:bg-slate-900",
          icon: <Check className="h-4 w-4 text-green-500" />,
        });

        // Avanzar al siguiente paso si corresponde
        const steps = [
          "Requests",
          "Suppliers",
          "Quotations",
          "PO Creation",
          "Delivery & Reconciliation",
        ];
        const currentIndex = steps.indexOf(selectedStep);
        if (currentIndex < steps.length - 1) {
          setSelectedStep(steps[currentIndex + 1]);
        }
      } else {
        toast({
          title: "Error",
          description: result.message || "Failed to approve step",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error("Error processing step:", error);
      toast({
        title: "Error",
        description: "An error occurred while processing the step",
        variant: "destructive",
      });
    }
  };

  // Función para manejar el rechazo después de la confirmación
  const handleConfirmReject = async () => {
    try {
      setIsRejectProcessing(true);
      const clientId = data?.client_id;
      const orderId = data?.id;
      const requesterEmail = data?.source_email;
      const requesterName = data?.created_by_name;

      if (!clientId || !orderId) {
        toast({
          title: "Error",
          description: "Faltan datos necesarios para procesar el rechazo",
          variant: "destructive",
        });
        return;
      }

      // Actualizar el estado local para marcar como rechazado
      setStepsApproved((prev) => ({
        ...prev,
        [selectedStep]: false,
      }));

      // Registrar en el log
      await addLog(`${selectedStep} step rejected.`, "warning", "Reject");
      await approveStep(clientId, orderId, "Reject");

      // Si se proporcionó un comentario, guardarlo
      if (rejectReason.trim()) {
        try {
          const user_name = currentUser?.name || "Usuario";
          const response = await createComment(
            clientId,
            orderId,
            `[REJECTION REASON] ${rejectReason.trim()}`,
            user_name
          );

          if (response.success) {
            // Agregar el comentario al estado local
            setComments((prev) => [...prev, response.data]);

            // Registrar en logs
            await addLog(
              `Rejection reason provided: ${rejectReason.trim()}`,
              "rejection_comment",
              selectedStep
            );
          }
        } catch (error) {
          console.error("Error saving rejection comment:", error);
        }
      }

      // Enviar correo de notificación de rechazo al solicitante
      if (requesterEmail) {
        try {
          const emailData = {
            requester_email: requesterEmail,
            requester_name: requesterName || "Solicitante",
            comment: rejectReason.trim(),
            status: "rejected", // Indicar que es un rechazo, no una revisión
            reviewer_name: currentUser?.name || "Equipo de Compras",
            attachments: [], // Opcional: podrías añadir adjuntos si es necesario
          };

          await sendIPRRejectionEmail(clientId, orderId, emailData);

          // Notificar al usuario que el correo se envió correctamente
          toast({
            title: "Correo enviado",
            description: `Se ha enviado una notificación de rechazo a ${requesterEmail}`,
            variant: "default",
            className: "border-green-500 bg-white dark:bg-slate-900",
            icon: <Check className="h-4 w-4 text-green-500" />,
          });
        } catch (error) {
          console.error("Error sending rejection email:", error);
          toast({
            title: "Error",
            description:
              "No se pudo enviar el correo de notificación de rechazo",
            variant: "destructive",
          });
        }
      }

      // Notificar al usuario que el rechazo se procesó correctamente
      toast({
        title: "IPR Rechazado",
        description: "El IPR ha sido rechazado correctamente.",
        variant: "default",
        className: "border-red-500 bg-white dark:bg-slate-900",
        icon: <XCircle className="h-4 w-4 text-red-500" />,
      });

      // Cerrar el modal y resetear el estado
      setShowRejectModal(false);
      setRejectReason("");

      // Cerrar el modal principal después de rechazar
      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (error) {
      console.error("Error processing rejection:", error);
      toast({
        title: "Error",
        description: "An error occurred while processing the rejection.",
        variant: "destructive",
      });
    } finally {
      setIsRejectProcessing(false);
    }
  };

  // Función para manejar la revisión después de la confirmación
  const handleConfirmReview = async () => {
    try {
      setIsReviewProcessing(true);
      const clientId = data?.client_id;
      const orderId = data?.order_id;
      const requesterEmail = data?.sender_email || data?.source_email;
      const requesterName = data?.created_by_name;

      if (!clientId || !orderId) {
        toast({
          title: "Error",
          description: "Faltan datos necesarios para procesar la revisión",
          variant: "destructive",
        });
        return;
      }

      // Actualizar el estado local para marcar como en revisión
      setStepsApproved((prev) => ({
        ...prev,
        [selectedStep]: false,
      }));

      // Registrar en el log
      await addLog(
        `${selectedStep} step marked for review and resubmit.`,
        "warning",
        "Review"
      );
      await approveStep(clientId, orderId, "Review");

      // Si se proporcionó un comentario, guardarlo
      if (reviewReason.trim()) {
        try {
          const user_name = currentUser?.name || "Usuario";
          const response = await createComment(
            clientId,
            orderId,
            `[REVIEW REASON] ${reviewReason.trim()}`,
            user_name
          );

          if (response.success) {
            // Agregar el comentario al estado local
            setComments((prev) => [...prev, response.data]);

            // Registrar en logs
            await addLog(
              `Review reason provided: ${reviewReason.trim()}`,
              "review_comment",
              selectedStep
            );
          }
        } catch (error) {
          console.error("Error saving review comment:", error);
        }
      }

      // Si no estamos mostrando la vista previa del correo, enviarlo directamente
      if (!showEmailPreview) {
        await sendReviewEmail();
      }

      // Notificar al usuario que la revisión se procesó correctamente
      toast({
        title: "Revisión Solicitada",
        description: "Se ha solicitado una revisión del IPR correctamente.",
        variant: "default",
        className: "border-orange-500 bg-white dark:bg-slate-900",
        icon: <RefreshCw className="h-4 w-4 text-orange-500" />,
      });

      // Si no estamos mostrando la vista previa del correo, cerrar el modal
      if (!showEmailPreview) {
        // Cerrar el modal y resetear el estado
        setShowReviewModal(false);
        setReviewReason("");
      }
    } catch (error) {
      console.error("Error processing review:", error);
      toast({
        title: "Error",
        description: "An error occurred while processing the review request.",
        variant: "destructive",
      });
    } finally {
      setIsReviewProcessing(false);
    }
  };

  // Función para enviar el correo de revisión
  const sendReviewEmail = async () => {
    const clientId = data?.client_id;
    const orderId = data?.order_id;
    const requesterEmail = data?.sender_email || data?.source_email;
    const requesterName = data?.created_by_name;

    if (requesterEmail) {
      try {
        const emailData = {
          requester_email: requesterEmail,
          requester_name: requesterName || "Solicitante",
          comment: reviewReason.trim(),
          status: "review", // Indicar que es una revisión, no un rechazo
          reviewer_name: currentUser?.name || "Equipo de Compras",
          attachments: [], // Opcional: podrías añadir adjuntos si es necesario
        };

        await sendIPRRejectionEmail(clientId, orderId, emailData);

        // Notificar al usuario que el correo se envió correctamente
        toast({
          title: "Correo enviado",
          description: `Se ha enviado una notificación de revisión a ${requesterEmail}`,
          variant: "default",
          className: "border-green-500 bg-white dark:bg-slate-900",
          icon: <Check className="h-4 w-4 text-green-500" />,
        });

        // Cerrar la vista previa del correo y el modal de revisión
        setShowEmailPreview(false);
        setShowReviewModal(false);
        setReviewReason("");
      } catch (error) {
        console.error("Error sending review email:", error);
        toast({
          title: "Error",
          description:
            "No se pudo enviar el correo de notificación de revisión",
          variant: "destructive",
        });
      }
    }
  };

  // Function to handle step transition
  const handleStepChange = async (newStep) => {
    // Updated step names array
    const steps = [
      "Requests",
      "Suppliers",
      "Quotations",
      "PO Creation",
      "Delivery & Reconciliation",
    ];
    const currentIndex = steps.indexOf(selectedStep);
    const newIndex = steps.indexOf(newStep);

    // If trying to move forward without approval
    if (newIndex > currentIndex && !stepsApproved[selectedStep]) {
      toast({
        title: "Action Required",
        description: `You need to approve the ${selectedStep} step before proceeding.`,
        variant: "destructive",
      });
      return;
    }

    // If trying to access a step that's more than one step ahead
    if (newIndex > currentIndex + 1) {
      const previousStep = steps[newIndex - 1];
      if (!stepsApproved[previousStep]) {
        toast({
          title: "Action Required",
          description: `You need to complete the ${previousStep} step first.`,
          variant: "destructive",
        });
        return;
      }
    }

    // Special case for Suppliers step - check if contractors are selected
    if (
      selectedStep === "Suppliers" &&
      newIndex > currentIndex &&
      selectedContractors.length === 0
    ) {
      toast({
        title: "Action Required",
        description:
          "You need to select at least one supplier before proceeding.",
        variant: "destructive",
      });
      return;
    }

    // If all checks pass, show processing state and change step
    setIsProcessing(true);
    setProcessingMessage(`Loading ${newStep} data...`);

    // Simulate loading time
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setSelectedStep(newStep);
    setIsProcessing(false);
  };

  // Function to check if a step is accessible
  const isStepAccessible = (step) => {
    // Updated step names array
    const steps = [
      "Requests",
      "Suppliers",
      "Quotations",
      "PO Creation",
      "Delivery & Reconciliation",
    ];
    const stepIndex = steps.indexOf(step);
    const currentIndex = steps.indexOf(selectedStep);

    // Current step is always accessible
    if (step === selectedStep) return true;

    // Previous steps are always accessible
    if (stepIndex < currentIndex) return true;

    // Next step is accessible if current step is approved
    if (stepIndex === currentIndex + 1 && stepsApproved[selectedStep])
      return true;

    // Steps further ahead require all previous steps to be approved
    if (stepIndex > currentIndex + 1) {
      for (let i = 0; i < stepIndex; i++) {
        if (!stepsApproved[steps[i]]) return false;
      }
      return true;
    }

    return false;
  };

  // Render the workflow steps section with accessibility checks
  const renderWorkflowSteps = () => {
    console.log("Current stepsApproved state:", stepsApproved);
    console.log("Current selectedStep:", selectedStep);

    return (
      <div className="flex items-center justify-center p-4 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50">
        <div className="flex flex-col sm:flex-row items-center max-w-4xl w-full">
          {/* Updated step names in the array */}
          {[
            "Requests",
            "Suppliers",
            "Quotations",
            "PO Creation",
            "Delivery & Reconciliation",
          ].map((step, index) => {
            const isCurrentStep =
              data?.current_step === step ||
              (index === 0 && !data?.current_step);
            const isPastStep = stepsApproved[step];
            const isSelected = selectedStep === step;
            const accessible = isStepAccessible(step);

            console.log(
              `Step ${step}: isPastStep=${isPastStep}, isSelected=${isSelected}, accessible=${accessible}`
            );

            return (
              <React.Fragment key={step}>
                <div
                  className={`flex flex-col items-center relative group ${
                    index > 0 ? "sm:ml-4" : ""
                  } ${
                    accessible
                      ? "cursor-pointer transition-all duration-200 hover:scale-105"
                      : "cursor-not-allowed opacity-60"
                  }`}
                  onClick={() => accessible && handleStepChange(step)}
                >
                  {/* Step circle */}
                  <div
                    className={`rounded-full w-12 h-12 flex items-center justify-center text-sm font-medium mb-2
                      ${
                        isSelected
                          ? "ring-2 ring-offset-2 ring-orange-500 shadow-md bg-orange-500 text-white"
                          : isPastStep
                          ? "bg-green-500 text-white"
                          : "bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-300"
                      }
                      transition-all duration-200 ease-in-out
                      ${isSelected ? "scale-110" : ""}
                      `}
                  >
                    {isPastStep ? <Check className="h-5 w-5" /> : index + 1}
                  </div>

                  {/* Step label */}
                  <span
                    className={`text-sm font-medium whitespace-nowrap ${
                      isSelected
                        ? "font-semibold text-orange-500 dark:text-orange-400 underline underline-offset-4"
                        : isPastStep
                        ? "text-green-600 dark:text-green-400"
                        : "text-slate-600 dark:text-slate-400"
                    }`}
                  >
                    {step}
                  </span>

                  {/* Status indicator */}
                  {isSelected && (
                    <span className="absolute -top-1 -right-1 flex h-3 w-3">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-500 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-orange-500"></span>
                    </span>
                  )}

                  {/* Lock icon for inaccessible steps */}
                  {!accessible && !isPastStep && (
                    <span className="absolute -top-1 -right-1 bg-slate-300 dark:bg-slate-600 rounded-full p-0.5">
                      <Lock className="h-3 w-3 text-slate-600 dark:text-slate-300" />
                    </span>
                  )}
                </div>

                {/* Connector line */}
                {index < 4 && ( // Updated to 4 since we now have 5 steps
                  <div className="hidden sm:block relative">
                    <div
                      className={`h-0.5 w-16 mx-2 ${
                        isPastStep
                          ? "bg-green-300 dark:bg-green-700"
                          : "bg-slate-200 dark:bg-slate-700"
                      }`}
                    />
                    {isPastStep && (
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-green-500 dark:bg-green-400 rounded-full" />
                    )}
                  </div>
                )}

                {/* Mobile separator (only visible on small screens) */}
                {index < 4 && ( // Updated to 4 since we now have 5 steps
                  <div className="sm:hidden h-6 w-px mx-auto my-1 bg-slate-200 dark:bg-slate-700"></div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  };

  // Render the action buttons based on current step and approval status
  const renderActionButtons = () => {
    // Don't show action buttons if the current step is already approved
    if (stepsApproved[selectedStep]) {
      return (
        <div className="flex items-center">
          <Badge
            variant="success"
            className="bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300 border border-green-300 dark:border-green-700"
          >
            <Check className="h-3.5 w-3.5 mr-1" /> Approved
          </Badge>
        </div>
      );
    }
    if (selectedStep === "Requests") {
      return (
        <div className="flex space-x-3 rounded">
          <Button
            variant="outline"
            size="sm"
            disabled={isProcessing}
            onClick={() => {
              setIsProcessing(true);
              setProcessingMessage("Processing approval...");

              // Llamar a la función de aprobación
              setTimeout(async () => {
                try {
                  await handleApproveStep();
                } catch (error) {
                  console.error("Error processing approval:", error);
                  toast({
                    title: "Error",
                    description:
                      "An error occurred while processing the approval.",
                    variant: "destructive",
                  });
                } finally {
                  setIsProcessing(false);
                  setSelectedStep("Suppliers");
                }
              }, 1500);
            }}
            className="text-green-600 border-green-300 hover:bg-green-50 dark:text-green-400 dark:border-green-600 dark:hover:bg-green-900/30 rounded"
          >
            {isProcessing ? (
              <>
                <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />{" "}
                Processing...
              </>
            ) : (
              <>
                <Check className="h-4 w-4 mr-1.5" /> Approve Request
              </>
            )}
          </Button>

          <Button
            variant="outline"
            size="sm"
            disabled={isProcessing}
            onClick={() => {
              setIsProcessing(true);
              setProcessingMessage("Processing rejection...");

              // Llamar a la función con el parámetro de rechazo
              setTimeout(async () => {
                try {
                  await handleApproveStep("reject");
                } catch (error) {
                  console.error("Error processing rejection:", error);
                  toast({
                    title: "Error",
                    description:
                      "An error occurred while processing the rejection.",
                    variant: "destructive",
                  });
                } finally {
                  setIsProcessing(false);
                }
              }, 1500);
            }}
            className="text-red-600 border-red-300 hover:bg-red-50 dark:text-red-400 dark:border-red-600 dark:hover:bg-red-900/30 rounded"
          >
            <XCircle className="h-4 w-4 mr-1.5" /> Reject
          </Button>

          <Button
            variant="outline"
            size="sm"
            disabled={isProcessing}
            onClick={async () => {
              try {
                setShowReviewModal(true);

                // Registrar acción en logs
                await addLog(
                  "Request marked for review and resend - adjustments are required for order: " +
                    data.order_id,
                  "warning",
                  "Review"
                );

                // Mantener el mismo paso pero marcar como no aprobado
                setStepsApproved((prev) => ({
                  ...prev,
                  [selectedStep]: false,
                }));

                // Abrir modal de comentarios si es necesario (implementar según necesidad)
                // setRevisionCommentModalOpen(true);
              } catch (error) {
                console.error("Error requesting review:", error);
              } finally {
                setIsProcessing(false);
              }
            }}
            className="text-orange-600 border-orange-300 hover:bg-orange-50 dark:text-orange-400 dark:border-orange-600 dark:hover:bg-orange-900/30 rounded"
          >
            <RefreshCw className="h-4 w-4 mr-1.5" /> Review and Resend
          </Button>
        </div>
      );
    }
    // Special case for PO Creation step - show different action buttons
    if (selectedStep === "PO Creation") {
      // Solo mostrar los botones si estamos en modo preview y tenemos datos de PO
      if (isPreview && poData) {
        return (
          <div className="flex space-x-3">
            <Button
              variant="outline"
              size="sm"
              className="text-slate-600 border-slate-300 rounded"
              onClick={() => {
                // Volver al paso anterior (Quotations)
                setSelectedStep("Quotations");
              }}
              disabled={isCreating}
            >
              <ArrowLeft className="h-4 w-4 mr-1.5" /> Back to Quotations
            </Button>

            <Button
              variant="default"
              size="sm"
              className="bg-green-600 hover:bg-green-700 text-white rounded"
              onClick={() => {
                setIsProcessing(true);
                setTimeout(() => {
                  handleApproveStep();
                  addLog(
                    `${selectedStep} step approved successfully.`,
                    "PO Creation"
                  );
                  setIsProcessing(false);
                }, 1500);
              }}
              disabled={isCreating}
            >
              {isCreating ? (
                <>
                  <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> Creating
                  PO...
                </>
              ) : (
                <>
                  <Check className="h-4 w-4 mr-1.5" /> Create Purchase Order
                </>
              )}
            </Button>
          </div>
        );
      } else if (!isPreview && poData) {
        // Si la PO ya está creada, no mostrar ningún botón
        return null;
      } else {
        // Si no hay datos de PO, no mostrar botones
        return null;
      }
    }

    // Special case for RFQ step - show different action button
    if (selectedStep === "Suppliers") {
      return (
        <Button
          variant="outline"
          size="sm"
          disabled={selectedSuppliersIds.length === 0}
          onClick={() => {
            setIsProcessing(true);
            handleSendRFQ(selectedSuppliersIds);
            setTimeout(async () => {
              try {
                await handleApproveStep();
              } catch (error) {
                console.error("Error approving step:", error);
              } finally {
                setIsProcessing(false);
                setSelectedStep("Quotations");
              }
            }, 1500);
          }}
          className="text-orange-600 border-orange-300 hover:bg-orange-50 dark:text-orange-400 dark:border-orange-600 dark:hover:bg-orange-900/30  rounded"
        >
          {isProcessing ? (
            <>
              <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> Processing...
            </>
          ) : (
            <>
              <Check className="h-4 w-4 mr-1.5" />
              Send RFQ to {selectedSuppliersIds.length} Supplier(s)
            </>
          )}
        </Button>
      );
    }

    // Special case for Quotations step - disable Approve if no supplier selected
    if (selectedStep === "Quotations") {
      const isCsApproveDisabled = !selectedCsSupplierId || isProcessing;
      const selectedSupplier = respondedContractors.find(
        (s) => s.id === selectedCsSupplierId
      );

      return (
        <>
          <TooltipProvider delayDuration={150}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span tabIndex={isCsApproveDisabled ? 0 : -1}>
                  <Button
                    variant="outline"
                    size="sm"
                    disabled={isCsApproveDisabled}
                    onClick={() => {
                      setIsProcessing(true);
                      setTimeout(async () => {
                        try {
                          await handleApproveStep();
                        } catch (error) {
                          console.error("Error approving step:", error);
                        } finally {
                          setIsProcessing(false);
                          addLog(
                            `Approved quotation from supplier ${
                              selectedSupplier?.name || selectedCsSupplierId
                            }`,
                            "Quotations"
                          );
                          setSelectedStep("PO Creation");
                        }
                      }, 1500);
                    }}
                    className="text-green-600 border-green-300 hover:bg-green-50 dark:text-green-400 dark:border-green-600 dark:hover:bg-green-900/30 disabled:opacity-50 disabled:cursor-not-allowed rounded"
                  >
                    {isProcessing ? (
                      <>
                        <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />{" "}
                        Processing...
                      </>
                    ) : (
                      <>
                        <Check className="h-4 w-4 mr-1.5" /> Approve Selected
                        Supplier
                      </>
                    )}
                  </Button>
                </span>
              </TooltipTrigger>
              {isCsApproveDisabled && !isProcessing && (
                <TooltipContent>
                  <p>Please select a supplier from the table first.</p>
                </TooltipContent>
              )}
            </Tooltip>
          </TooltipProvider>

          <Button
            variant="outline"
            size="sm"
            disabled={isProcessing}
            onClick={() => {
              setIsProcessing(true);
              setProcessingMessage("Processing rejection...");

              // Llamar a la función con el parámetro de rechazo
              setTimeout(async () => {
                try {
                  await handleApproveStep("reject");
                } catch (error) {
                  console.error("Error processing rejection:", error);
                  toast({
                    title: "Error",
                    description:
                      "An error occurred while processing the rejection.",
                    variant: "destructive",
                  });
                } finally {
                  setIsProcessing(false);
                }
              }, 1500);
            }}
            className="text-gray-600 border-gray-300 hover:bg-gray-50 dark:text-gray-400 dark:border-red-600 dark:hover:bg-red-900/30 ml-2 rounded"
          >
            <XCircle className="h-4 w-4 mr-1.5" /> Reject
          </Button>
        </>
      );
    }

    if (selectedStep === "Delivery & Reconciliation") {
      return null;
    }

    // Default action buttons for other steps
    return (
      <>
        <Button
          variant="outline"
          size="sm"
          disabled={isProcessing}
          onClick={() => {
            setIsProcessing(true);
            setTimeout(async () => {
              try {
                await handleApproveStep();
              } catch (error) {
                console.error("Error approving step:", error);
                addLog(`${selectedStep} step rejected.`, selectedStep);
              } finally {
                setIsProcessing(false);
              }
            }, 1500);
          }}
          className="text-green-600 border-green-300 hover:bg-green-50 dark:text-green-400 dark:border-green-600 dark:hover:bg-green-900/30 rounded"
        >
          {isProcessing ? (
            <>
              <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> Processing...
            </>
          ) : (
            <>
              <Check className="h-4 w-4 mr-1.5" /> Approve
            </>
          )}
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={isProcessing}
          onClick={() => {
            setIsProcessing(true);
            setProcessingMessage("Processing rejection...");

            // Llamar a la función con el parámetro de rechazo
            setTimeout(async () => {
              try {
                await handleApproveStep("reject");
              } catch (error) {
                console.error("Error processing rejection:", error);
                toast({
                  title: "Error",
                  description:
                    "An error occurred while processing the rejection.",
                  variant: "destructive",
                });
              } finally {
                setIsProcessing(false);
                addLog(`${selectedStep} step rejected.`, selectedStep);
              }
            }, 1500);
          }}
          className="text-gray-600 border-gray-300 hover:bg-gray-50 dark:text-gray-400 dark:border-red-600 dark:hover:bg-red-900/30 ml-2 rounded"
        >
          <XCircle className="h-4 w-4 mr-1.5" /> Reject
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={isProcessing}
          onClick={() => {
            // Abrir modal de revisión
            setShowReviewModal(true);
          }}
          className="text-orange-600 border-orange-300 hover:bg-orange-50 dark:text-orange-400 dark:border-orange-600 dark:hover:bg-orange-900/30 rounded"
        >
          <RefreshCw className="h-4 w-4 mr-1.5" /> Revise & Resubmit
        </Button>
      </>
    );
  };

  // Add processing overlay
  const renderProcessingOverlay = () => {
    if (!isProcessing) return null;

    return (
      <div className="absolute inset-0 bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm z-50 flex items-center justify-center">
        <div className="bg-white dark:bg-slate-800 rounded shadow-xl p-6 max-w-md text-center">
          <Loader2 className="h-10 w-10 animate-spin mx-auto mb-4 text-orange-500" />
          <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-2">
            {processingMessage || "Processing..."}
          </h3>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            Please wait while we process your request.
          </p>
        </div>
      </div>
    );
  };

  // Update the header buttons to include log viewing
  const renderHeaderButtons = () => {
    return (
      <div className="flex items-center space-x-2">
        {!isGridView && selectedStep !== "Files" && (
          <>
            {renderActionButtons()}
            <span className="w-px h-5 bg-slate-200 dark:bg-slate-700 mx-2"></span>
          </>
        )}

        {/* View Logs Button */}
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setShowLogModal(true)}
          className="text-slate-600 dark:text-slate-400"
        >
          <History className="h-4 w-4 mr-1.5" /> Logs
        </Button>

        {/*         <Button
          variant="ghost"
          size="sm"
          onClick={toggleGridView}
          className="text-slate-600 dark:text-slate-400"
        >
          {isGridView ? (
            <>
              <FileText className="h-4 w-4 mr-1.5" /> Document View
            </>
          ) : (
            <>
              <LayoutGrid className="h-4 w-4 mr-1.5" /> Grid View
            </>
          )}
        </Button>

            <Button
          variant="ghost"
          size="sm"
          onClick={toggleFullscreen}
          className="text-slate-600 dark:text-slate-400"
        >
          {isFullscreen ? (
            <>
              <Minimize2 className="h-4 w-4 mr-1.5" /> Exit Fullscreen
            </>
          ) : (
            <>
              <Maximize2 className="h-4 w-4 mr-1.5" /> Fullscreen
            </>
          )}
        </Button> */}

        {/* Close Button */}
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="text-slate-600 dark:text-slate-400"
        >
          <X className="h-4 w-4 mr-1.5" /> Close
        </Button>
      </div>
    );
  };

  // Renderizar la tabla de IPR con los datos reales

  // Añade esta función para manejar el envío de RFQ
  const handleSendRFQ = async (selectedSuppliersIds) => {
    try {
      // Obtener el ID del cliente y de la orden del estado actual
      const clientId = data?.client_id;
      const orderId = data?.order_id;
      const workflowId = 1;

      if (!clientId || !orderId) {
        addLog("Error: Missing client ID or order ID", "error");
        return;
      }

      // Llamar al endpoint para crear cotizaciones
      const result = await createQuotationsForSuppliers(
        clientId,
        orderId,
        selectedSuppliersIds
      );

      if (result.success) {
        // Obtener los datos completos de los proveedores seleccionados
        const allSuppliers = await getSuppliers(clientId);
        const selectedSuppliers = allSuppliers.data.filter((supplier) =>
          selectedSuppliersIds.includes(supplier.id)
        );

        // Preparar opciones para el correo

        // Enviar correos a los proveedores seleccionados
        const emailResult = await sendEmailToSuppliers(
          clientId,
          workflowId,
          orderId,
          selectedSuppliers
        );

        if (emailResult.success) {
          addLog(
            `Emails sent successfully to ${emailResult.data.successCount} suppliers`,
            "success",
            "Suppliers"
          );
        } else {
          addLog(
            `Failed to send emails: ${emailResult.message || "Unknown error"}`,
            "warning",
            "Suppliers"
          );
        }
      } else {
        addLog(
          `Failed to create RFQ: ${result.message || "Unknown error"}`,
          "error",
          "Suppliers"
        );
      }
    } catch (error) {
      console.error("Error in RFQ process:", error);
      addLog(`Error in RFQ process: ${error.message}`, "error", "Suppliers");
    }
  };

  // Modificar el useEffect para cargar y cachear los items de cotización
  useEffect(() => {
    const loadQuotationItems = async () => {
      if (
        (selectedStep === "Quotations" || selectedStep === "PO Creation") &&
        data?.client_id &&
        data?.order_id
      ) {
        try {
          // Primero intentar cargar desde localStorage
          const cachedItems = localStorage.getItem(
            `quotation_items_${data.order_id}`
          );

          if (cachedItems) {
            const parsedItems = JSON.parse(cachedItems);
            setQuotationItems(parsedItems);

            // Si estamos en el paso de Quotations, verificar si necesitamos actualizar los datos
            if (selectedStep === "Quotations") {
              setIsLoadingQuotationItems(true);
              fetchFreshData();
            }
          } else {
            // Si no hay datos en caché, cargar desde la API
            setIsLoadingQuotationItems(true);
            fetchFreshData();
          }
        } catch (error) {
          console.error("Error loading quotation items:", error);
          addLog(`Error loading quotation items: ${error.message}`, "error");
          setQuotationItems([]);
          setIsLoadingQuotationItems(false);
        }
      }

      // Función para obtener datos frescos de la API
      async function fetchFreshData() {
        try {
          const result = await getQuotationItemsByOrderId(
            data.clientId,
            data.id
          );

          if (result.success && Array.isArray(result.data)) {
            setQuotationItems(result.data);

            // Guardar en localStorage para uso futuro
            localStorage.setItem(
              `quotation_items_${data.order_id}`,
              JSON.stringify(result.data)
            );
            console.log("Saved quotation items to cache:", result.data.length);
            console.log("Quotation items:", result.data);
          } else {
            setQuotationItems([]);
          }
        } catch (error) {
          console.error("Error fetching quotation items:", error);
          addLog(`Error fetching quotation items: ${error.message}`, "error");
        } finally {
          setIsLoadingQuotationItems(false);
        }
      }
    };

    loadQuotationItems();
  }, [selectedStep, data?.client_id, data?.order_id]);

  // Modificar el useEffect para cargar los datos de la cotización cuando cambiamos al paso de PO Creation
  useEffect(() => {
    if (selectedStep === "PO Creation" && !poData) {
      console.log(
        "Loading PO data, selected supplier ID:",
        selectedCsSupplierId
      );

      // Intentar obtener el ID del proveedor seleccionado, ya sea del estado o de localStorage
      const supplierId =
        selectedCsSupplierId ||
        localStorage.getItem(`selected_supplier_${data?.order_id}`);

      console.log("Using supplier ID for PO:", supplierId);

      if (!supplierId) {
        setError(
          "No supplier selected. Please select a supplier in the Quotations step."
        );
        addLog("Error: No supplier selected for PO creation", "error");
        return;
      }

      // Cargar los items de cotización directamente desde la caché
      const cachedItems = localStorage.getItem(
        `quotation_items_${data?.order_id}`
      );
      console.log("Raw cached items:", cachedItems);

      if (cachedItems) {
        try {
          const allItems = JSON.parse(cachedItems);
          console.log("Parsed cached quotation items:", allItems);

          // Buscar el proveedor seleccionado
          const selectedSupplier = orderSuppliers.find(
            (supplier) =>
              supplier.id === supplierId ||
              supplier.id === parseInt(supplierId) ||
              String(supplier.id) === String(supplierId)
          );

          console.log("Selected supplier:", selectedSupplier);

          if (!selectedSupplier) {
            console.error(
              `Supplier with ID ${supplierId} not found in`,
              orderSuppliers
            );
            setError(`Supplier with ID ${supplierId} not found`);
            addLog(`Error: Supplier with ID ${supplierId} not found`, "error");
            return;
          }

          // IMPORTANTE: Los items no tienen supplier_id, sino quote_id
          // Necesitamos obtener los quote_ids asociados con este proveedor
          console.log("Supplier quotations:", selectedSupplier.quotations);

          // Si el proveedor tiene cotizaciones, usarlas para filtrar items
          let selectedSupplierItems = allItems; // Usar los items de la caché, no la función setState

          if (
            selectedSupplier.quotations &&
            selectedSupplier.quotations.length > 0
          ) {
            // Filtrar por quote_id
            const supplierQuoteIds = selectedSupplier.quotations.map(
              (q) => q.id
            );
            console.log("Supplier quote IDs:", supplierQuoteIds);

            selectedSupplierItems = allItems.filter(
              (item) =>
                supplierQuoteIds.includes(item.quote_id) ||
                supplierQuoteIds.includes(parseInt(item.quote_id))
            );

            console.log("Items filtered by quote_id:", selectedSupplierItems);
          } else {
            // Plan B: Si no hay cotizaciones, mostrar todos los items
            console.warn("No quotations found for supplier, showing all items");
            selectedSupplierItems = allItems;
          }

          // Si aún no tenemos items, mostrar todos como último recurso
          if (selectedSupplierItems.length === 0) {
            console.warn(
              "No items found for supplier quotations, showing all items"
            );
            selectedSupplierItems = allItems;
          }

          // Crear los datos de la PO con los items filtrados
          const poItems = selectedSupplierItems.map((item, index) => {
            const quantity = parseInt(item.quantity) || 1;
            const unitPrice = parseFloat(item.unit_price || 0);
            const total = unitPrice * quantity;

            return {
              id: index + 1,
              item_id: item.order_item_id,
              item_code: item.item_code || `Item-${index + 1}`,
              description: item.item_description || `Item ${index + 1}`,
              quantity: quantity,
              unit_price: unitPrice,
              total: total,
            };
          });

          console.log("Created PO items:", poItems);

          const totalAmount = poItems.reduce(
            (sum, item) => sum + item.total,
            0
          );

          setPOData({
            poNumber: `PO-${new Date().getFullYear()}-${Math.floor(
              1000 + Math.random() * 9000
            )}`,
            issueDate: new Date().toLocaleDateString(),
            expectedDeliveryDate: new Date(
              Date.now() + 14 * 24 * 60 * 60 * 1000
            ).toLocaleDateString(),
            supplierName: selectedSupplier.name,
            supplierId: selectedSupplier.id,
            items: poItems,
            totalAmount: totalAmount,
            isPreview: true,
          });

          // También guardar en localStorage para futuras referencias
          localStorage.setItem(
            `po_data_${data?.order_id}`,
            JSON.stringify({
              supplierId: selectedSupplier.id,
              supplierName: selectedSupplier.name,
              items: selectedSupplierItems,
              totalAmount: totalAmount,
            })
          );

          addLog(
            `Generated purchase order preview for ${selectedSupplier.name} with ${selectedSupplierItems.length} items`,
            "PO Creation"
          );
          return;
        } catch (error) {
          console.error("Error processing cached quotation items:", error);
          setError(`Error processing quotation data: ${error.message}`);
          addLog(
            `Error processing quotation data: ${error.message}`,
            "error",
            "PO Creation"
          );
        }
      } else {
        console.warn("No cached quotation items found");
      }

      // Si llegamos aquí, no pudimos cargar los datos
      setError(
        "No quotation data available. Please go back to the Quotations step and select a supplier."
      );
      addLog(
        "Error: No quotation data available for PO creation",
        "error",
        "PO Creation"
      );
    }
  }, [
    selectedStep,
    poData,
    selectedCsSupplierId,
    orderSuppliers,
    data?.order_id,
  ]);

  // Función para crear la orden de compra
  const handleCreatePO = async () => {
    try {
      setIsCreating(true);

      // Obtener datos de localStorage
      const poDataString = localStorage.getItem(`po_data_${data?.order_id}`);
      if (!poDataString) {
        toast({
          title: "Error",
          description: "No se encontraron datos para crear la orden de compra",
          variant: "destructive",
        });
        return;
      }

      const poData = JSON.parse(poDataString);
      console.log("PO data loaded from localStorage:", poData);

      // Simular la creación de la PO (solo actualizar el estado)
      setPOData({
        poNumber: `PO-${new Date().getFullYear()}-${Math.floor(
          1000 + Math.random() * 9000
        )}`,
        issueDate: new Date().toLocaleDateString(),
        expectedDeliveryDate: new Date(
          Date.now() + 14 * 24 * 60 * 60 * 1000
        ).toLocaleDateString(),
        supplierName: poData.supplierName,
        supplierId: poData.supplierId,
        items: poData.items,
        totalAmount: poData.totalAmount,
        isPreview: false,
      });

      // Registrar en logs
      await addLog(
        `Purchase Order created for supplier: ${poData.supplierName}`,
        "PO Creation"
      );

      // Mostrar notificación de éxito
      toast({
        title: "Success",
        description: "Purchase Order created successfully",
        variant: "success",
      });

      // Obtener el proveedor seleccionado
      const selectedSupplier = orderSuppliers.find(
        (s) => s.id === poData.supplierId
      );
      console.log("Selected supplier:", selectedSupplier);

      if (!selectedSupplier) {
        console.error("Supplier not found:", poData.supplierId);
        toast({
          title: "Warning",
          description:
            "Supplier information not found. Email notifications could not be sent.",
          variant: "warning",
        });
        setIsPreview(false);
        setIsCreating(false);
        return;
      }

      console.log("Preparing to send email notification");
      console.log("Client ID:", data.client_id);
      console.log("Workflow ID:", data.workflow_id);
      console.log("Order ID:", data.order_id);
      console.log("Requester email:", data.requester_email);

      // Preparar array de proveedores (solo el seleccionado)
      const suppliersToNotify = [
        {
          id: selectedSupplier.id,
          name: selectedSupplier.name,
          contact_email: selectedSupplier.contact_email, // Email de respaldo si no hay uno real
        },
      ];

      console.log("Suppliers to notify:", suppliersToNotify);

      try {
        console.log("Calling sendEmailToSupplierAndRequester endpoint");

        // Enviar correos
        const emailResponse = await sendEmailToSupplierAndRequester(
          data.client_id,
          data.workflow_id,
          data.order_id,
          suppliersToNotify,
          data.requester_email || "jairo@mantisapp.co", // Email de respaldo si no hay uno real
          `Purchase Order Created: #${data.order_id}`,
          [], // attachments (opcional)
          "Sistema" // nombre del usuario actual
        );

        console.log("Email endpoint response:", emailResponse);

        if (emailResponse && emailResponse.success) {
          toast({
            title: "Notifications Sent",
            description:
              "Email notifications have been sent to the supplier and requester",
            variant: "success",
          });

          await addLog(
            `Email notifications sent to supplier ${selectedSupplier.name} and requester`,
            "PO Creation"
          );
        } else {
          console.error("Email endpoint returned error:", emailResponse);
          toast({
            title: "Warning",
            description: `Failed to send notifications: ${
              emailResponse?.message || "Unknown error"
            }`,
            variant: "warning",
          });
        }
      } catch (emailError) {
        console.error("Error sending email notifications:", emailError);
        toast({
          title: "Warning",
          description: `Purchase Order created but there was an error sending notifications: ${emailError.message}`,
          variant: "warning",
        });
      }

      // Actualizar el estado para mostrar la PO creada
      setIsPreview(false);
    } catch (error) {
      console.error("Error creating PO:", error);
      toast({
        title: "Error",
        description:
          error.message ||
          "An error occurred while creating the Purchase Order",
        variant: "destructive",
      });
    } finally {
      setIsCreating(false);
    }
  };

  // Añadir un nuevo useEffect para persistir el proveedor seleccionado entre pasos
  useEffect(() => {
    // Cuando se selecciona un proveedor, guardarlo en localStorage
    if (selectedCsSupplierId) {
      localStorage.setItem(
        `selected_supplier_${data?.order_id}`,
        selectedCsSupplierId
      );
      console.log(
        "Saved selected supplier ID to localStorage:",
        selectedCsSupplierId
      );
    }
  }, [selectedCsSupplierId, data?.order_id]);

  // Añadir un useEffect para cargar el proveedor seleccionado al iniciar o cambiar de paso
  useEffect(() => {
    // Solo cargar si no hay un proveedor seleccionado actualmente
    if (!selectedCsSupplierId) {
      const savedSupplierId = localStorage.getItem(
        `selected_supplier_${data?.order_id}`
      );
      if (savedSupplierId) {
        console.log(
          "Loaded selected supplier ID from localStorage:",
          savedSupplierId
        );
        setSelectedCsSupplierId(savedSupplierId);
      }
    }
  }, [selectedStep, selectedCsSupplierId, data?.order_id]);
  // Efecto para cargar los items de cotización cuando cambia el paso
  useEffect(() => {
    let isMounted = true;

    const loadQuotationData = async () => {
      if (selectedStep === "Quotations" && data?.order_id) {
        try {
          await loadQuotationItems(
            data.client_id,
            data.workflow_id,
            data.order_id,
            setQuotationItems,
            setIsLoadingQuotationItems,
            toast
          );
        } catch (error) {
          console.error("Error loading quotation items:", error);
          if (isMounted) {
            toast({
              title: "Error",
              description: "Failed to load quotation items",
              variant: "destructive",
            });
          }
        }
      }
    };

    loadQuotationData();

    return () => {
      isMounted = false;
    };
  }, [selectedStep, data?.order_id, data?.client_id, data?.workflow_id, toast]);

  // Efecto para cargar datos del PO y manejar la selección de proveedores
  useEffect(() => {
    const loadPoAndSupplierData = async () => {
      try {
        if (data?.order_id) {
          // Cargar datos del PO
          const savedPoData = localStorage.getItem(`po_data_${data.order_id}`);
          if (savedPoData) {
            const parsedData = JSON.parse(savedPoData);
            setPOData(parsedData);

            // Si hay items en el PO, actualizar los items de cotización
            if (parsedData.items && parsedData.items.length > 0) {
              setQuotationItems(parsedData.items);
            }
          }

          // Cargar proveedor seleccionado
          const savedSupplier = localStorage.getItem(
            `selected_supplier_${data.order_id}`
          );
          if (savedSupplier) {
            const { supplierId } = JSON.parse(savedSupplier);
            setSelectedSupplierId(supplierId);
            if (selectedStep === "Quotations") {
              setSelectedCsSupplierId(supplierId);
            }
          }
        }
      } catch (error) {
        console.error("Error loading PO and supplier data:", error);
        toast({
          title: "Error",
          description: "Failed to load saved data",
          variant: "destructive",
        });
      }
    };

    loadPoAndSupplierData();
  }, [data?.order_id, selectedStep, toast]);

  // Efecto para filtrar items por proveedor seleccionado
  useEffect(() => {
    if (poData?.items && poData.items.length > 0 && poData.supplierId) {
      setQuotationItems(poData.items);
    }
  }, [poData]);
  // Añadir este useEffect para cargar logs cuando se abre el modal
  useEffect(() => {
    const loadLogs = async () => {
      if (data?.client_id && data?.order_id && showLogModal) {
        try {
          setIsLoadingLogs(true);

          const response = await getLogsByOrderId(
            data.client_id,
            data.order_id
          );

          if (response && Array.isArray(response.data)) {
            // Simplemente pasar el timestamp tal como viene de la BD
            const formattedLogs = response.data.map((log) => ({
              timestamp: log.timestamp, // Mantener el formato ISO original
              user: log.user_name || "Sistema",
              action: log.action,
              details: log.details,
            }));

            setProcessLogs(formattedLogs);
            console.log(
              `Cargados ${formattedLogs.length} logs para la orden ${data.order_id}`
            );
          } else {
            console.warn(
              "Formato de respuesta incorrecto para logs:",
              response
            );
            setProcessLogs([]);
          }
        } catch (error) {
          console.error("Error al cargar logs del sistema:", error);
          toast({
            title: "Error al cargar historial",
            description: "No se pudo cargar el historial de actividad.",
            variant: "destructive",
          });
          setProcessLogs([]);
        } finally {
          setIsLoadingLogs(false);
        }
      }
    };

    loadLogs();
  }, [data?.client_id, data?.order_id, showLogModal]);

  // Modificar el botón que abre el modal de logs
  const handleOpenLogsModal = () => {
    setShowLogModal(true);
  };

  <Button
    variant="outline"
    size="sm"
    onClick={handleOpenLogsModal}
    className="flex items-center text-slate-600 dark:text-slate-300"
  >
    <ClipboardList className="h-4 w-4 mr-1.5" />
    Ver Historial
  </Button>;

  // Agregar esta función para cargar comentarios
  const loadComments = async () => {
    if (!data?.client_id || !data?.order_id) return;

    try {
      const response = await getCommentsByOrderId(
        data.client_id,
        data.order_id
      );
      if (response.success && response.data) {
        setComments(response.data);
      }
    } catch (error) {
      console.error("Error al cargar comentarios:", error);
      setCommentError("No se pudieron cargar los comentarios");
    }
  };

  // Añadir este useEffect para cargar el estado de aprobación de los pasos
  useEffect(() => {
    const loadApprovalFlow = async () => {
      if (isOpen && data?.client_id && data?.order_id) {
        try {
          console.log("Fetching approval flow for order:", data.order_id);
          const result = await getApprovalFlow(data.client_id, data.order_id);

          console.log("Approval flow API response:", result);

          if (result.success && result.data) {
            // Definir el orden de los pasos
            const stepOrder = [
              "Requests",
              "Suppliers",
              "Quotations",
              "PO Creation",
              "Delivery & Reconciliation",
            ];

            // Crear un objeto para almacenar el estado de aprobación de cada paso
            const approvedSteps = {};

            // Mapear los datos de la API al formato que necesitamos
            result.data.forEach((item) => {
              console.log(
                `Step ${item.step}: is_approved = ${item.is_approved}`
              );
              approvedSteps[item.step] = item.is_approved;
            });

            console.log("Processed approval steps:", approvedSteps);

            // Actualizar el estado con los pasos aprobados
            setStepsApproved(approvedSteps);

            // Encontrar el primer paso no aprobado
            const firstUnapprovedStep = stepOrder.find(
              (step) => !approvedSteps[step]
            );

            console.log("First unapproved step:", firstUnapprovedStep);

            // Si todos los pasos están aprobados, seleccionar el último
            if (firstUnapprovedStep) {
              setSelectedStep(firstUnapprovedStep);
            } else {
              setSelectedStep(stepOrder[stepOrder.length - 1]);
            }

            // Registrar en el log
          }
        } catch (error) {
          console.error("Error loading approval flow:", error);
          addLog("Failed to load approval flow status", "error", "PO Creation");
        }
      }
    };

    loadApprovalFlow();
  }, [isOpen, data?.client_id, data?.order_id]);

  // Añadir estas funciones para manejar los botones de refresh y export
  const handleRefreshLogs = useCallback(async () => {
    if (!data?.order_id) return;

    try {
      setIsLoadingLogs(true);
      // Llamar a la API para obtener los logs actualizados
      const response = await getLogsByOrderId(data.client_id, data.order_id);

      if (response && response.success) {
        setProcessLogs(response.data || []);
        toast({
          title: "Logs refreshed",
          description: `${response.data?.length || 0} activity records loaded`,
          variant: "default",
        });
      } else {
        toast({
          title: "Error refreshing logs",
          description: response?.message || "Could not refresh activity logs",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error("Error refreshing logs:", error);
      toast({
        title: "Error refreshing logs",
        description: error.message || "An unexpected error occurred",
        variant: "destructive",
      });
    } finally {
      setIsLoadingLogs(false);
    }
  }, [data?.client_id, data?.order_id, toast]);

  // Función para exportar logs a CSV
  const handleExportLogs = useCallback(() => {
    if (!processLogs || processLogs.length === 0) {
      toast({
        title: "Nothing to export",
        description: "There are no activity records to export",
        variant: "warning",
      });
      return;
    }

    try {
      // Crear cabeceras CSV
      const headers = ["Date", "Time", "User", "Action"];

      // Formatear los datos para CSV
      const csvData = processLogs.map((log) => {
        const timestamp = log.timestamp ? new Date(log.timestamp) : new Date();
        const date = timestamp.toLocaleDateString();
        const time = timestamp.toLocaleTimeString();

        return [
          date,
          time,
          log.user || "Unknown",
          log.action || "No description",
        ];
      });

      // Combinar cabeceras y datos
      const csvContent = [
        headers.join(","),
        ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(",")),
      ].join("\n");

      // Crear blob y link para descargar
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      // Configurar y simular clic en el link
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `activity_log_${data?.order_id || "export"}_${
          new Date().toISOString().split("T")[0]
        }.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast({
        title: "Export successful",
        description: `${processLogs.length} records exported to CSV`,
        variant: "default",
      });
    } catch (error) {
      console.error("Error exporting logs:", error);
      toast({
        title: "Export failed",
        description: error.message || "Could not export activity logs",
        variant: "destructive",
      });
    }
  }, [processLogs, data?.order_id, toast]);

  // Early exit if modal is not open or no data (assuming similar checks exist or are desired)
  if (!isOpen) {
    return null;
  }

  // Check if the IPR step is "Reject"
  // Using trim() and toLowerCase() for a more robust check
  const isRejected = data?.step?.trim().toLowerCase() === "reject";

  const renderHeader = () => {
    return (
      <div
        className={`flex items-center justify-between p-4 border-b ${
          isRejected
            ? "border-red-300 dark:border-red-600 bg-red-100 dark:bg-red-800/40"
            : "border-slate-200 dark:border-slate-700"
        } flex-shrink-0`}
      >
        <h2
          className={`text-lg font-semibold ${
            isRejected
              ? "text-red-700 dark:text-red-100"
              : "text-slate-800 dark:text-slate-100"
          }`}
        >
          {isRejected && (
            <AlertTriangle className="h-5 w-5 mr-2 inline-block text-red-600 dark:text-red-400" />
          )}
          {isGridView
            ? "PR Oracle Format"
            : "Purchase Request" + " #" + data?.order_id}
          {isRejected && (
            <span className="ml-2 text-sm font-normal">(Rechazado)</span>
          )}
        </h2>
        {renderHeaderButtons()}
      </div>
    );
  };

  // Función para manejar la selección de proveedores
  const handleSelectSupplier = async (supplierId) => {
    await handleSupplierSelection(
      supplierId,
      data,
      setSelectedSupplierId,
      setSelectedCsSupplierId,
      selectedStep,
      addLog
    );
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key="loaded-state"
        className={`bg-white dark:bg-slate-900 rounded shadow-xl overflow-hidden w-[90vw] ${
          isFullscreen ? "fixed inset-0 z-[100] w-[100vw]" : "relative h-[90vh]"
        } flex flex-col relative`}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.2 }}
      >
        {/* Processing overlay */}
        {renderProcessingOverlay()}

        {renderHeader()}

        {/* Banner de Rechazo */}
        {isRejected && (
          <div className="p-3 bg-red-100 dark:bg-red-800/50 border-b border-red-300 dark:border-red-600 text-center">
            <div className="flex items-center justify-center">
              <AlertTriangle className="h-5 w-5 mr-2 text-red-700 dark:text-red-300" />
              <p className="text-sm font-medium text-red-800 dark:text-red-200">
                Este IPR ha sido rechazado. La información es de solo lectura.
              </p>
            </div>
          </div>
        )}

        {/* Workflow steps section */}
        {selectedStep !== "Files" && renderWorkflowSteps()}

        {/* Step content */}
        <div className="flex-1 overflow-y-scroll">{renderStepContent()}</div>
      </motion.div>

      {/* Modal para mostrar los Logs - Corregido el overlay persistente */}
      <Dialog
        open={showLogModal}
        onOpenChange={setShowLogModal}
        className="relative z-[200]"
      >
        <DialogContent
          className="sm:max-w-5xl p-0 overflow-hidden bg-white dark:bg-slate-900 rounded border-0 shadow-xl"
          style={{
            position: "fixed",
            zIndex: 200,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <div className="flex flex-col h-full max-h-[85vh]">
            {/* Header con degradado sutil */}
            <div className="bg-gradient-to-r from-indigo-50 to-slate-50 dark:from-indigo-950/30 dark:to-slate-900 px-6 py-5 border-b border-slate-200/70 dark:border-slate-700/70">
              <div className="flex items-center justify-between mb-2">
                <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100 flex items-center">
                  <ClipboardList className="h-5 w-5 text-indigo-500 mr-2.5" />
                  Activity Timeline
                </h2>
                <DialogClose className="h-8 w-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"></DialogClose>
              </div>
              <p className="text-sm text-slate-500 dark:text-slate-400 max-w-2xl">
                Track the complete history of actions and status changes
                throughout this request's lifecycle.
              </p>
            </div>

            {/* Barra de búsqueda y filtros */}
            <div className="px-6 py-3 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800">
              <div className="flex flex-wrap items-center gap-3">
                <div className="relative flex-1 min-w-[240px]">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                  <input
                    type="text"
                    placeholder="Search activity..."
                    className="w-full h-10 pl-10 pr-4 text-sm rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500/30 dark:focus:ring-indigo-500/40 focus:border-indigo-500"
                  />
                </div>

                {/* Filtros tipo chip */}
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-slate-500 dark:text-slate-400">
                    Filter:
                  </span>
                  <div className="flex flex-wrap gap-2">
                    <button className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-indigo-500 dark:hover:border-indigo-500 transition-colors group">
                      <span className="w-2 h-2 rounded-full bg-slate-400 mr-1.5 group-hover:bg-indigo-500 transition-colors"></span>
                      All
                    </button>
                    <button className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-purple-400 dark:hover:border-purple-400 transition-colors group">
                      <span className="w-2 h-2 rounded-full bg-purple-500 mr-1.5"></span>
                      System
                    </button>
                    <button className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-blue-400 dark:hover:border-blue-400 transition-colors group">
                      <span className="w-2 h-2 rounded-full bg-blue-500 mr-1.5"></span>
                      Supplier
                    </button>
                    <button className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-amber-400 dark:hover:border-amber-400 transition-colors group">
                      <span className="w-2 h-2 rounded-full bg-amber-500 mr-1.5"></span>
                      Warnings
                    </button>
                    <button className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-red-400 dark:hover:border-red-400 transition-colors group">
                      <span className="w-2 h-2 rounded-full bg-red-500 mr-1.5"></span>
                      Errors
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Contenedor de logs con scroll - COMBINANDO AMBOS DISEÑOS */}
            <div className="flex-1 overflow-y-auto custom-scrollbar bg-slate-50/70 dark:bg-slate-800/20">
              {isLoadingLogs ? (
                <div className="flex flex-col items-center justify-center h-full py-12">
                  <div className="w-12 h-12 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin mb-4"></div>
                  <p className="text-sm text-slate-500 dark:text-slate-400">
                    Loading activity history...
                  </p>
                </div>
              ) : processLogs && processLogs.length > 0 ? (
                <div className="px-6 py-4">
                  {/* Agrupación por fecha */}
                  {(() => {
                    // Agrupar logs por fecha
                    const dateGroups = {};
                    processLogs.forEach((log) => {
                      const dateKey = log.timestamp
                        ? new Date(log.timestamp).toISOString().split("T")[0]
                        : "Unknown Date";
                      if (!dateGroups[dateKey]) dateGroups[dateKey] = [];
                      dateGroups[dateKey].push(log);
                    });

                    // Ordenar las fechas (más recientes primero)
                    const sortedDates = Object.keys(dateGroups)
                      .sort()
                      .reverse();

                    // Renderizar grupos por fecha
                    return sortedDates.map((dateKey, groupIndex) => {
                      const logs = dateGroups[dateKey];
                      const displayDate =
                        dateKey !== "Unknown Date"
                          ? new Date(dateKey).toLocaleDateString("en-US", {
                              weekday: "long",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          : "Unknown Date";

                      // Determinar si es "Hoy", "Ayer" o fecha completa
                      const today = new Date().toISOString().split("T")[0];
                      const yesterday = new Date(Date.now() - 86400000)
                        .toISOString()
                        .split("T")[0];

                      let dateLabel = displayDate;
                      if (dateKey === today) {
                        dateLabel = `Today - ${displayDate}`;
                      } else if (dateKey === yesterday) {
                        dateLabel = `Yesterday - ${displayDate}`;
                      }

                      return (
                        <div key={dateKey} className="mb-8">
                          {/* Cabecera de fecha */}
                          <div className="flex items-center mb-4">
                            <div className="h-8 w-8 rounded-full bg-indigo-100 dark:bg-indigo-900/50 border-2 border-white dark:border-slate-800 flex items-center justify-center mr-3">
                              <Calendar className="h-4 w-4 text-indigo-500" />
                            </div>
                            <h3 className="text-sm font-medium text-slate-700 dark:text-slate-300">
                              {dateLabel}
                            </h3>
                            <div className="ml-3 h-[1px] flex-grow bg-slate-200 dark:bg-slate-700"></div>
                          </div>

                          {/* Tabla de logs para este día */}
                          <div className="ml-10">
                            {/* Cabecera de tabla */}
                            <div className="grid grid-cols-12 gap-4 px-4 py-2 bg-slate-100 dark:bg-slate-800 rounded-t-lg border border-slate-200 dark:border-slate-700 mb-1 text-xs font-medium text-slate-500 dark:text-slate-400">
                              <div className="col-span-2">Time</div>
                              <div className="col-span-3">User</div>
                              <div className="col-span-7">Description</div>
                            </div>

                            {/* Filas de logs */}
                            <div className="divide-y divide-slate-100 dark:divide-slate-800/80 rounded-b-lg overflow-hidden border border-t-0 border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
                              {logs.map((log, index) => {
                                // Determinar el tipo de log para estilos
                                const isError = log.action?.includes("ERROR");
                                const isWarning =
                                  log.action?.includes("ADVERTENCIA") ||
                                  log.action?.includes("WARNING");
                                const isSystem =
                                  log.user === "Mantis" ||
                                  log.user === "System";
                                const isSupplier =
                                  log.user?.includes("INC.") ||
                                  log.user?.includes("QATAR") ||
                                  log.user?.includes("SOLUTIONS");

                                // Determinar colores según tipo
                                const colorClass = isError
                                  ? "text-red-600 dark:text-red-400"
                                  : isWarning
                                  ? "text-amber-600 dark:text-amber-400"
                                  : isSystem
                                  ? "text-purple-600 dark:text-purple-400"
                                  : isSupplier
                                  ? "text-blue-600 dark:text-blue-400"
                                  : "text-slate-700 dark:text-slate-300";

                                // Determinar icono según tipo
                                let icon = <UserCircle className="h-4 w-4" />;
                                if (isError)
                                  icon = (
                                    <AlertCircle className="h-4 w-4 text-red-500" />
                                  );
                                else if (isWarning)
                                  icon = (
                                    <AlertTriangle className="h-4 w-4 text-amber-500" />
                                  );
                                else if (isSystem)
                                  icon = (
                                    <Cpu className="h-4 w-4 text-purple-500" />
                                  );
                                else if (isSupplier)
                                  icon = (
                                    <Building className="h-4 w-4 text-blue-500" />
                                  );

                                return (
                                  <div
                                    key={index}
                                    className={`grid grid-cols-12 gap-4 px-4 py-3 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors text-sm ${
                                      isError
                                        ? "border-l-2 border-l-red-500"
                                        : isWarning
                                        ? "border-l-2 border-l-amber-500"
                                        : isSystem
                                        ? "border-l-2 border-l-purple-500"
                                        : isSupplier
                                        ? "border-l-2 border-l-blue-500"
                                        : ""
                                    }`}
                                  >
                                    {/* Hora */}
                                    <div className="col-span-2 flex items-center">
                                      <Clock className="h-3.5 w-3.5 text-slate-400 mr-2 flex-shrink-0" />
                                      <div className="text-xs font-mono text-slate-500 dark:text-slate-400">
                                        {log.timestamp
                                          ? formatTimestamp(log.timestamp).time
                                          : "-"}
                                      </div>
                                    </div>

                                    {/* Usuario */}
                                    <div className="col-span-3 flex items-center">
                                      <div
                                        className={`w-7 h-7 rounded-full flex items-center justify-center mr-2 flex-shrink-0 ${
                                          isError
                                            ? "bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400"
                                            : isWarning
                                            ? "bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400"
                                            : isSystem
                                            ? "bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400"
                                            : isSupplier
                                            ? "bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"
                                            : "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400"
                                        }`}
                                      >
                                        {icon}
                                      </div>
                                      <span
                                        className={`text-xs font-medium truncate ${colorClass}`}
                                      >
                                        {log.user || "Unknown"}
                                      </span>
                                    </div>

                                    {/* Descripción */}
                                    <div
                                      className={`col-span-7 ${colorClass} text-sm leading-relaxed break-words`}
                                    >
                                      {log.action}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-full py-20 px-6">
                  <div className="w-20 h-20 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center mb-4">
                    <ClipboardX className="h-10 w-10 text-slate-400 dark:text-slate-600" />
                  </div>
                  <h3 className="text-lg font-medium text-slate-700 dark:text-slate-300 mb-2 text-center">
                    No activity records yet
                  </h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400 max-w-md text-center mb-6">
                    This request doesn't have any recorded activity. Actions
                    performed on this request will appear here automatically.
                  </p>
                  <button className="inline-flex items-center px-4 py-2 rounded bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-100 dark:hover:bg-indigo-900/50 transition-colors text-sm font-medium">
                    {isLoadingLogs ? (
                      <>
                        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                        Loading...
                      </>
                    ) : (
                      <>
                        <RefreshCw className="h-4 w-4 mr-2" />
                        Refresh Activity
                      </>
                    )}
                  </button>
                </div>
              )}
            </div>

            {/* Footer con acciones */}
            <div className="px-6 py-3 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 flex justify-between items-center">
              <div className="text-xs text-slate-500 dark:text-slate-400">
                {processLogs && processLogs.length
                  ? `${processLogs.length} activities found`
                  : "No activities"}
              </div>
              <div className="flex space-x-2">
                <button
                  className="px-3 py-1.5 rounded border border-slate-200 dark:border-slate-700 text-xs text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
                  onClick={handleExportLogs}
                  disabled={!processLogs || processLogs.length === 0}
                >
                  <Download className="h-3.5 w-3.5 mr-1.5 inline-block" />
                  Export
                </button>
                <button
                  className="px-3 py-1.5 rounded bg-indigo-500 hover:bg-indigo-600 text-xs text-white transition-colors"
                  onClick={handleRefreshLogs}
                  disabled={isLoadingLogs}
                >
                  {isLoadingLogs ? (
                    <>
                      <Loader2 className="h-3.5 w-3.5 mr-1.5 inline-block animate-spin" />
                      Loading...
                    </>
                  ) : (
                    <>
                      <RefreshCw className="h-3.5 w-3.5 mr-1.5 inline-block" />
                      Refresh
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </DialogContent>

        {/* Overlay personalizado - Solo visible cuando showLogModal es true */}
        {showLogModal && (
          <div
            className="fixed inset-0 bg-black/50 z-[199]"
            style={{
              position: "fixed",
              zIndex: 199,
            }}
            onClick={() => setShowLogModal(false)}
          />
        )}
      </Dialog>
      {showSupplierModal && (
        <SupplierModal
          supplier={selectedSupplierForEdit}
          mode={supplierModalMode}
          clientId={data?.client_id}
        />
      )}
      {showDocumentPanel && (
        <div
          className={`p-4 overflow-auto h-full flex ${
            showDocumentPanel ? "flex-row" : "flex-col"
          }`}
        >
          {/* Panel de documentos (visible solo cuando showDocumentPanel es true) */}
          {showDocumentPanel && (
            <div className="w-1/2 pr-4 flex flex-col h-full">
              <div className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 p-4 shadow-sm mb-4 flex justify-between items-center">
                <h3 className="text-base font-semibold text-slate-800 dark:text-slate-200 flex items-center">
                  <FileText className="h-5 w-5 mr-2 text-blue-600 dark:text-blue-400" />
                  Supplier Documents
                </h3>
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-8 w-8 p-0 rounded-full"
                  onClick={() => {
                    setShowDocumentPanel(false);
                    setSelectedDocument(null);
                  }}
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
              <p className="text-xs text-slate-500 dark:text-slate-400 mb-1">
                View and download documents provided by the supplier.
              </p>

              {isLoadingDocuments ? (
                <div className="flex justify-center items-center py-12 bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 shadow-sm">
                  <div className="text-center">
                    <Loader2 className="h-8 w-8 animate-spin text-blue-500 mx-auto mb-2" />
                    <span className="text-sm text-slate-600 dark:text-slate-400">
                      Loading documents...
                    </span>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col h-[calc(100vh-240px)]">
                  {/* Lista de documentos */}
                  {supplierDocuments.length > 0 ? (
                    <div className="mb-4 bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 p-4 shadow-sm">
                      <h4 className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-3 flex items-center">
                        <Files className="h-4 w-4 mr-1.5 text-blue-500" />
                        Available Documents
                      </h4>
                      <div className="space-y-2 max-h-[200px] overflow-y-auto pr-1 custom-scrollbar">
                        {supplierDocuments.map((doc) => (
                          <div
                            key={doc.id}
                            className={`p-2.5 rounded cursor-pointer flex items-center justify-between ${
                              selectedDocument?.id === doc.id
                                ? "bg-blue-50 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border border-blue-200 dark:border-blue-800"
                                : "bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 border border-slate-100 dark:border-slate-700"
                            }`}
                            onClick={() => setSelectedDocument(doc)}
                          >
                            <div className="flex items-center">
                              <div className="h-8 w-8 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mr-2 flex-shrink-0">
                                {doc.document_type === "pdf" ? (
                                  <FileText className="h-4 w-4 text-red-500" />
                                ) : doc.document_type === "image" ? (
                                  <Image className="h-4 w-4 text-blue-500" />
                                ) : (
                                  <File className="h-4 w-4 text-slate-500" />
                                )}
                              </div>
                              <div>
                                <span className="text-sm font-medium truncate block max-w-[180px]">
                                  {doc.name}
                                </span>
                                <span className="text-xs text-slate-500 dark:text-slate-400">
                                  {doc.document_type?.toUpperCase() ||
                                    "Document"}{" "}
                                  • {doc.size || "Unknown size"}
                                </span>
                              </div>
                            </div>
                            <Badge
                              variant="outline"
                              className="text-xs ml-2 flex-shrink-0"
                            >
                              {doc.status || "Available"}
                            </Badge>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="mb-4 bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 p-6 shadow-sm text-center">
                      <div className="mx-auto w-12 h-12 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mb-3">
                        <FileX className="h-6 w-6 text-slate-500 dark:text-slate-400" />
                      </div>
                      <h3 className="text-sm font-medium text-slate-800 dark:text-slate-200 mb-1">
                        No Documents Available
                      </h3>
                      <p className="text-xs text-slate-500 dark:text-slate-400">
                        This supplier hasn't uploaded any documents yet.
                      </p>
                    </div>
                  )}

                  {/* Visualizador de documento */}
                  {selectedDocument ? (
                    <div className="flex-1 bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col shadow-sm">
                      <div className="p-3 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 flex justify-between items-center">
                        <h4 className="text-sm font-medium text-slate-700 dark:text-slate-300 truncate max-w-[200px]">
                          {selectedDocument.name}
                        </h4>
                        <div className="flex items-center space-x-2">
                          <Badge variant="outline" className="text-xs">
                            {selectedDocument.document_type}
                          </Badge>
                          <div className="flex items-center space-x-1">
                            {/* Botón de descarga */}
                            <a
                              href={selectedDocument.url}
                              download={selectedDocument.name}
                              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 p-1 rounded hover:bg-blue-50 dark:hover:bg-blue-900/30"
                              title="Download document"
                            >
                              <Download className="h-4 w-4" />
                            </a>
                            {/* Botón para abrir en nueva pestaña */}
                            <a
                              href={selectedDocument.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 p-1 rounded hover:bg-blue-50 dark:hover:bg-blue-900/30"
                              title="Open in new tab"
                            >
                              <Maximize2 className="h-4 w-4" />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="flex-1 overflow-hidden bg-slate-100 dark:bg-slate-900/50 p-4">
                        {/* Solución para la vista previa en localhost */}
                        {selectedDocument.document_type ===
                        "application/pdf" ? (
                          <div className="w-full h-full flex items-center justify-center bg-slate-200 dark:bg-slate-700 rounded overflow-hidden">
                            <iframe
                              src={selectedDocument.url}
                              className="w-full h-full min-h-[500px]"
                            />
                          </div>
                        ) : selectedDocument.document_type === "image" ? (
                          <div className="w-full h-full flex items-center justify-center bg-slate-200 dark:bg-slate-700 rounded">
                            <img
                              src={selectedDocument.url}
                              alt={selectedDocument.name}
                              className="max-w-full max-h-full object-contain"
                            />
                          </div>
                        ) : (
                          <div className="w-full h-full flex flex-col items-center justify-center bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 p-6">
                            <div className="w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mb-3">
                              <File className="h-8 w-8 text-slate-500" />
                            </div>
                            <h3 className="text-sm font-medium text-slate-800 dark:text-slate-200 mb-2">
                              Preview Unavailable
                            </h3>
                            <p className="text-xs text-slate-500 dark:text-slate-400 text-center mb-4 max-w-md">
                              This document type cannot be previewed. Please
                              download it to view its contents.
                            </p>
                            <a
                              href={selectedDocument.url}
                              download={selectedDocument.name}
                              className="inline-flex items-center px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded transition-colors"
                            >
                              <Download className="h-3.5 w-3.5 mr-1.5" />
                              Download Document
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="flex-1 flex justify-center items-center bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 shadow-sm">
                      <div className="text-center p-6">
                        <div className="mx-auto w-12 h-12 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center mb-3">
                          <FileSearch className="h-6 w-6 text-slate-500 dark:text-slate-400" />
                        </div>
                        <h3 className="text-sm font-medium text-slate-800 dark:text-slate-200 mb-1">
                          Select a Document
                        </h3>
                        <p className="text-xs text-slate-500 dark:text-slate-400">
                          Choose a document from the list above to preview or
                          download it.
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Contenido original (ajustado para ocupar el espacio restante) */}
          <div className={showDocumentPanel ? "w-1/2" : "w-full"}>
            {/* Aquí va todo el contenido original de renderCsContent */}
            {/* ... */}
          </div>
        </div>
      )}
      {/* Modal de confirmación de rechazo */}
      <Dialog open={showRejectModal} onOpenChange={setShowRejectModal}>
        <DialogContent className="sm:max-w-md z-[60]" style={{ zIndex: 9999 }}>
          <DialogHeader>
            <DialogTitle className="flex items-center text-red-600">
              <AlertTriangle className="h-5 w-5 mr-2" />
              Confirm Reject
            </DialogTitle>
            <DialogDescription>
              Are you sure you want to reject this IPR? This action cannot be
              undone.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-2">
            <div className="space-y-2">
              <label
                htmlFor="reject-reason"
                className="text-sm font-medium text-slate-700 dark:text-slate-300"
              >
                Rejection Reason (Optional)
              </label>
              <Textarea
                id="reject-reason"
                placeholder="Explain why you are rejecting this IPR..."
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                className="w-full min-h-[100px]"
              />
            </div>
          </div>

          <DialogFooter className="sm:justify-between">
            <Button
              variant="outline"
              onClick={() => {
                setShowRejectModal(false);
                setRejectReason("");
              }}
              disabled={isRejectProcessing}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={handleConfirmReject}
              disabled={isRejectProcessing}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              {isRejectProcessing ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />{" "}
                  Processing...
                </>
              ) : (
                <>
                  <XCircle className="h-4 w-4 mr-2" /> Confirm Reject
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>

        {/* Overlay personalizado - Solo visible cuando showRejectModal es true */}
        {showRejectModal && (
          <div
            className="fixed inset-0 bg-black/50 z-[199]"
            style={{
              position: "fixed",
              zIndex: 199,
            }}
            onClick={() => setShowRejectModal(false)}
          />
        )}
      </Dialog>

      {/* Modal de confirmación de revisión */}
      <Dialog open={showReviewModal} onOpenChange={setShowReviewModal}>
        <DialogContent className="sm:max-w-md z-[60]" style={{ zIndex: 9999 }}>
          <DialogHeader>
            <DialogTitle className="flex items-center text-orange-600">
              <RefreshCw className="h-5 w-5 mr-2" />
              Request Review
            </DialogTitle>
            <DialogDescription>
              Request the sender to review and resend this IPR with adjustments.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-2">
            <div className="space-y-2">
              <label
                htmlFor="review-reason"
                className="text-sm font-medium text-slate-700 dark:text-slate-300"
              >
                Review Reason (Optional)
              </label>
              <Textarea
                id="review-reason"
                placeholder="Explain what adjustments are needed in this IPR..."
                value={reviewReason}
                onChange={(e) => setReviewReason(e.target.value)}
                className="w-full min-h-[100px]"
              />
            </div>
          </div>

          <DialogFooter className="sm:justify-between">
            <Button
              variant="outline"
              onClick={() => {
                setShowReviewModal(false);
                setReviewReason("");
              }}
              disabled={isReviewProcessing}
            >
              Cancel
            </Button>
            <div className="flex space-x-2">
              {/*               <Button
                variant="outline"
                onClick={() => {
                  setShowEmailPreview(true);
                  handleConfirmReview();
                }}
                disabled={!reviewReason.trim() || isReviewProcessing}
                className="bg-slate-100 hover:bg-slate-200 text-slate-700"
              >
                <Eye className="h-4 w-4 mr-2" /> Vista Previa
              </Button> */}
              <Button
                variant="default"
                onClick={handleConfirmReview}
                disabled={!reviewReason.trim() || isReviewProcessing}
                className="bg-orange-600 hover:bg-orange-700 text-white"
              >
                {isReviewProcessing ? (
                  <>
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />{" "}
                    Processing...
                  </>
                ) : (
                  <>
                    <RefreshCw className="h-4 w-4 mr-2" /> Resubmit
                  </>
                )}
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>

        {/* Overlay personalizado - Solo visible cuando showReviewModal es true */}
        {showReviewModal && (
          <div
            className="fixed inset-0 bg-black/50 z-[199]"
            style={{
              position: "fixed",
              zIndex: 199,
            }}
            onClick={() => setShowReviewModal(false)}
          />
        )}
      </Dialog>

      {/* Modal de vista previa del correo */}
      <Dialog open={showEmailPreview} onOpenChange={setShowEmailPreview}>
        <DialogContent className="sm:max-w-2xl z-[70]" style={{ zIndex: 9999 }}>
          <DialogHeader>
            <DialogTitle className="flex items-center text-slate-800">
              <Mail className="h-5 w-5 mr-2" />
              Email Preview
            </DialogTitle>
            <DialogDescription>
              Here's how the email will look like to the sender.
            </DialogDescription>
          </DialogHeader>

          <div className="border rounded p-4 bg-white">
            <div className="border-b pb-2 mb-3">
              <div className="flex justify-between mb-1">
                <span className="text-sm font-medium text-slate-600">
                  From:
                </span>
                <span className="text-sm text-slate-800">
                  Purchasing Team &lt;purchasing@mantisbusiness.com&gt;
                </span>
              </div>
              <div className="flex justify-between mb-1">
                <span className="text-sm font-medium text-slate-600">To:</span>
                <span className="text-sm text-slate-800">
                  {data?.sender_email ||
                    data?.source_email ||
                    "sender@example.com"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm font-medium text-slate-600">
                  Subject:
                </span>
                <span className="text-sm text-slate-800">
                  Review Request for IPR #{data?.order_id}
                </span>
              </div>
            </div>

            <div className="email-body bg-slate-50 p-4 rounded">
              <p className="mb-3">Dear {data?.created_by_name || "User"},</p>

              <p className="mb-3">
                Your purchase request (IPR #{data?.order_id}) requires review
                and adjustments before it can proceed.
              </p>

              <div className="mb-3 bg-orange-50 border border-orange-200 p-3 rounded">
                <p className="font-medium mb-1 text-orange-800">
                  Review reason:
                </p>
                <p className="text-slate-700">{reviewReason}</p>
              </div>

              <p className="mb-3">
                Please make the necessary adjustments and resubmit the request
                for approval.
              </p>

              <p className="mb-3">
                If you have any questions or need assistance, please don't
                hesitate to contact us.
              </p>

              <p className="mb-1">Best regards,</p>
              <p className="font-medium">
                {currentUser?.name || "Purchasing Team"}
              </p>
              <p>Mantis Business</p>
            </div>
          </div>

          <DialogFooter className="sm:justify-between">
            <Button
              variant="outline"
              onClick={() => {
                setShowEmailPreview(false);
              }}
              disabled={isReviewProcessing}
            >
              Edit Message
            </Button>
            <Button
              variant="default"
              onClick={sendReviewEmail}
              disabled={isReviewProcessing}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              {isReviewProcessing ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" /> Sending...
                </>
              ) : (
                <>
                  <Send className="h-4 w-4 mr-2" /> Send Email
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>

        {/* Overlay personalizado - Solo visible cuando showEmailPreview es true */}
        {showEmailPreview && (
          <div
            className="fixed inset-0 bg-black/50 z-[199]"
            style={{
              position: "fixed",
              zIndex: 199,
            }}
            onClick={() => setShowEmailPreview(false)}
          />
        )}
      </Dialog>
    </AnimatePresence>
  );
}

// Función mejorada para formatear timestamp con mejor manejo de errores
const formatTimestamp = (timestamp) => {
  if (!timestamp) {
    console.log("Timestamp vacío o inválido:", timestamp);
    return { date: 'Fecha no disponible', time: 'Hora no disponible' };
  }

  try {
    const date = new Date(timestamp);

    // Verificar si la fecha es válida
    if (isNaN(date.getTime())) {
      console.log("Fecha inválida:", timestamp);
      return { date: 'Formato inválido', time: 'Formato inválido' };
    }

    // Formatear fecha como DD/MM/YYYY
    const dateString = date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    // Formatear hora como HH:MM:SS
    const timeString = date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    return { date: dateString, time: timeString };
  } catch (error) {
    console.error("Error al formatear timestamp:", error, "Valor:", timestamp);
    return { date: 'Error', time: 'Error' };
  }
};
